(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gosarte-faq"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-faq-section]').forEach(section=>{
  if(section.dataset.faqBound==='true')return;section.dataset.faqBound='true';
  const input=section.querySelector('[data-faq-search]'),filters=[...section.querySelectorAll('[data-faq-filter]')],items=[...section.querySelectorAll('[data-faq-item]')],empty=section.querySelector('[data-faq-empty]');
  let category='all';
  const apply=()=>{const q=(input?.value||'').trim().toLowerCase();let visible=0;items.forEach(item=>{const categoryMatch=category==='all'||item.dataset.category===category;const queryMatch=!q||(item.dataset.search||'').includes(q);const show=categoryMatch&&queryMatch;item.hidden=!show;if(!show)item.open=false;if(show)visible++});if(empty)empty.hidden=visible>0};
  filters.forEach(button=>button.addEventListener('click',()=>{category=button.dataset.faqFilter||'all';filters.forEach(item=>item.classList.toggle('is-active',item===button));apply()}));
  input?.addEventListener('input',apply);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gosarte-main-blog"]) return;
  try {
    
(() => {
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-journal-magic]').forEach(root => {
      if (root.dataset.journalMagicBound === 'true') return;
      root.dataset.journalMagicBound = 'true';
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const reveal = [...root.querySelectorAll('.jm-reveal')];
      if (reduce || !('IntersectionObserver' in window)) {
        reveal.forEach(el => el.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: .12, rootMargin: '0px 0px -8% 0px' });
        reveal.forEach(el => observer.observe(el));
      }
      if (!reduce && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
        root.addEventListener('pointermove', event => {
          const rect = root.getBoundingClientRect();
          root.style.setProperty('--jm-x', (((event.clientX - rect.left) / Math.max(1, rect.width)) * 100).toFixed(1) + '%');
          root.style.setProperty('--jm-y', (((event.clientY - rect.top) / Math.max(1, rect.height)) * 100).toFixed(1) + '%');
        }, { passive: true });
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', event => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gosarte-product-slider"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot=(scope=document)=>scope.querySelectorAll('[data-product-cinema]').forEach(root=>{
    if(root.dataset.productCinemaBound==='true')return;
    root.dataset.productCinemaBound='true';
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(reduce||!fine)return;
    root.addEventListener('pointermove',e=>{const r=root.getBoundingClientRect();root.style.setProperty('--prod-x',(((e.clientX-r.left)/Math.max(1,r.width))*100).toFixed(1)+'%');root.style.setProperty('--prod-y',(((e.clientY-r.top)/Math.max(1,r.height))*100).toFixed(1)+'%')},{passive:true});
    root.querySelectorAll('.gs-luxe-product-card').forEach(card=>{
      card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect();const x=((e.clientX-r.left)/Math.max(1,r.width)-.5)*2;const y=((e.clientY-r.top)/Math.max(1,r.height)-.5)*2;card.style.transform='perspective(950px) rotateX('+(-y*1.8).toFixed(2)+'deg) rotateY('+(x*2.5).toFixed(2)+'deg) translateY(-4px)'},{passive:true});
      card.addEventListener('pointerleave',()=>card.style.removeProperty('transform'));
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gosarte-seo-discovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot=(scope=document)=>scope.querySelectorAll('[data-seo-ritual]').forEach(root=>{
    if(root.dataset.seoRitualBound==='true')return;
    root.dataset.seoRitualBound='true';
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(reduce||!fine)return;
    root.addEventListener('pointermove',event=>{
      const rect=root.getBoundingClientRect();
      root.style.setProperty('--sr-x',(((event.clientX-rect.left)/Math.max(1,rect.width))*100).toFixed(1)+'%');
      root.style.setProperty('--sr-y',(((event.clientY-rect.top)/Math.max(1,rect.height))*100).toFixed(1)+'%');
    },{passive:true});
    root.querySelectorAll('[data-seo-ritual-card]').forEach(card=>{
      let frame=0,x=0,y=0;
      const paint=()=>{frame=0;card.style.transform='perspective(1000px) rotateX('+(-y*2.2).toFixed(2)+'deg) rotateY('+(x*3).toFixed(2)+'deg) translateY(-4px)'};
      card.addEventListener('pointermove',event=>{
        const rect=card.getBoundingClientRect();
        x=((event.clientX-rect.left)/Math.max(1,rect.width)-.5)*2;
        y=((event.clientY-rect.top)/Math.max(1,rect.height)-.5)*2;
        card.style.setProperty('--card-x',(((event.clientX-rect.left)/Math.max(1,rect.width))*100).toFixed(1)+'%');
        card.style.setProperty('--card-y',(((event.clientY-rect.top)/Math.max(1,rect.height))*100).toFixed(1)+'%');
        if(!frame)frame=requestAnimationFrame(paint);
      },{passive:true});
      card.addEventListener('pointerleave',()=>{card.style.removeProperty('transform')});
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gosarte-story-collections"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.gsWorldsBound === 'true') return;
    root.dataset.gsWorldsBound = 'true';
    const rail = root.querySelector('[data-gs-worlds-rail]');
    const cards = [...root.querySelectorAll('[data-gs-world]')];
    const progress = root.querySelector('[data-gs-worlds-progress]');
    if (!rail || cards.length < 2 || !progress) return;

    let raf = 0;
    const sync = () => {
      raf = 0;
      const center = rail.scrollLeft + rail.clientWidth / 2;
      let active = 0;
      let distance = Infinity;

      cards.forEach((card, index) => {
        const cardCenter = card.offsetLeft + card.offsetWidth / 2;
        const delta = Math.abs(cardCenter - center);
        if (delta < distance) {
          distance = delta;
          active = index;
        }
      });

      cards.forEach((card, index) => card.classList.toggle('is-active', index === active));
      progress.style.width = (((active + 1) / cards.length) * 100).toFixed(2) + '%';
    };

    rail.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(sync);
    }, { passive: true });

    sync();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-gs-worlds]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gosarte-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot=(scope=document)=>scope.querySelectorAll('[data-gugc]').forEach(root=>{
    if(root.dataset.gugcBound==='true')return;
    root.dataset.gugcBound='true';

    const slot=document.querySelector('[data-gpdp-ugc-slot]');
    if(slot&&!slot.contains(root)){
      root.classList.add('is-inline');
      slot.append(root);
      const wrapper=slot.closest('.gpdp-info');
      if(wrapper)wrapper.classList.add('has-inline-ugc');
      requestAnimationFrame(()=>root.classList.add('is-inline-ready'));
    }else if(slot&&slot.contains(root)){
      root.classList.add('is-inline','is-inline-ready');
    }

    const rail=root.querySelector('[data-gugc-rail]');
    const cards=[...root.querySelectorAll('[data-gugc-card]')];
    const prev=root.querySelector('[data-gugc-prev]');
    const next=root.querySelector('[data-gugc-next]');
    const current=root.querySelector('[data-gugc-current]');
    if(!rail||!cards.length)return;

    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    const autoplay=root.dataset.autoplay==='true';
    const ratios=new Map(cards.map(card=>[card,0]));
    let activeIndex=0;
    let rootVisible=true;
    let dragging=false;
    let dragMoved=false;
    let dragX=0;
    let dragScroll=0;

    const videoAt=index=>cards[index]?.querySelector('video');
    const updateButtonState=card=>{
      const video=card.querySelector('video');
      const play=card.querySelector('[data-gugc-play]');
      const sound=card.querySelector('[data-gugc-sound]');
      if(!video)return;
      card.classList.toggle('is-playing',!video.paused);
      card.classList.toggle('is-sound',!video.muted);
      if(play)play.setAttribute('aria-label',video.paused?root.dataset.playLabel:root.dataset.pauseLabel);
      if(sound)sound.setAttribute('aria-label',video.muted?root.dataset.soundOnLabel:root.dataset.soundOffLabel);
    };

    const updateCurrent=index=>{
      activeIndex=Math.max(0,Math.min(cards.length-1,index));
      cards.forEach((card,i)=>card.classList.toggle('is-active',i===activeIndex));
      if(current)current.textContent=String(activeIndex+1).padStart(2,'0');
    };

    const pauseOthers=keep=>{
      cards.forEach(card=>{
        if(card===keep)return;
        const video=card.querySelector('video');
        if(video&&!video.paused)video.pause();
        updateButtonState(card);
      });
    };

    const playCard=(card,automatic=false)=>{
      const video=card?.querySelector('video');
      if(!video)return;
      pauseOthers(card);
      if(automatic)video.muted=true;
      updateCurrent(cards.indexOf(card));
      const promise=video.play();
      if(promise&&typeof promise.catch==='function')promise.catch(()=>{});
      updateButtonState(card);
    };

    const pauseAll=()=>{
      cards.forEach(card=>{
        const video=card.querySelector('video');
        if(video&&!video.paused)video.pause();
        updateButtonState(card);
      });
    };

    const chooseActive=()=>{
      let bestIndex=activeIndex;
      let bestRatio=.48;
      ratios.forEach((ratio,card)=>{
        if(ratio>bestRatio){
          bestRatio=ratio;
          bestIndex=cards.indexOf(card);
        }
      });
      updateCurrent(bestIndex);
      if(autoplay&&!reduced&&rootVisible&&!document.hidden&&bestRatio>.54)playCard(cards[bestIndex],true);
      else if(bestRatio<=.2)pauseAll();
    };

    const goTo=index=>{
      const nextIndex=(index+cards.length)%cards.length;
      updateCurrent(nextIndex);
      cards[nextIndex].scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest',inline:'center'});
      if(autoplay&&!reduced&&rootVisible&&!document.hidden){
        window.setTimeout(()=>playCard(cards[nextIndex],true),reduced?0:260);
      }
    };

    prev?.addEventListener('click',()=>goTo(activeIndex-1));
    next?.addEventListener('click',()=>goTo(activeIndex+1));

    rail.addEventListener('keydown',event=>{
      if(event.key==='ArrowLeft'){event.preventDefault();goTo(activeIndex-1)}
      if(event.key==='ArrowRight'){event.preventDefault();goTo(activeIndex+1)}
      if((event.key===' '||event.key==='Enter')&&event.target===rail){
        event.preventDefault();
        const video=videoAt(activeIndex);
        if(video?.paused)playCard(cards[activeIndex],false);else video?.pause();
      }
    });

    if(fine){
      rail.addEventListener('pointerdown',event=>{
        if(event.target.closest('button'))return;
        dragging=true;dragMoved=false;dragX=event.clientX;dragScroll=rail.scrollLeft;
        rail.setPointerCapture?.(event.pointerId);
      });
      rail.addEventListener('pointermove',event=>{
        if(!dragging)return;
        const delta=event.clientX-dragX;
        if(Math.abs(delta)>4)dragMoved=true;
        rail.scrollLeft=dragScroll-delta;
      });
      const endDrag=event=>{
        if(!dragging)return;
        dragging=false;
        rail.releasePointerCapture?.(event.pointerId);
      };
      rail.addEventListener('pointerup',endDrag);
      rail.addEventListener('pointercancel',endDrag);
      rail.addEventListener('pointerleave',event=>{if(dragging)endDrag(event)});
    }

    cards.forEach((card,index)=>{
      const video=card.querySelector('video');
      const media=card.querySelector('[data-gugc-media]');
      const play=card.querySelector('[data-gugc-play]');
      const sound=card.querySelector('[data-gugc-sound]');
      const focus=card.querySelector('[data-gugc-focus]');
      const progress=card.querySelector('[data-gugc-progress]');
      if(!video)return;

      video.muted=true;
      video.playsInline=true;

      const updateProgress=()=>{
        if(!progress)return;
        const ratio=video.duration>0&&Number.isFinite(video.duration)?video.currentTime/video.duration:0;
        progress.style.width=Math.max(0,Math.min(1,ratio))*100+'%';
      };

      video.addEventListener('play',()=>{updateCurrent(index);updateButtonState(card)});
      video.addEventListener('pause',()=>updateButtonState(card));
      video.addEventListener('timeupdate',updateProgress);
      video.addEventListener('loadedmetadata',updateProgress);

      play?.addEventListener('click',event=>{
        event.stopPropagation();
        if(video.paused)playCard(card,false);
        else video.pause();
      });

      sound?.addEventListener('click',event=>{
        event.stopPropagation();
        video.muted=!video.muted;
        if(video.paused)playCard(card,false);
        updateButtonState(card);
      });

      focus?.addEventListener('click',event=>{
        event.stopPropagation();
        playCard(card,false);
        if(video.requestFullscreen)video.requestFullscreen().catch(()=>{});
        else if(typeof video.webkitEnterFullscreen==='function')video.webkitEnterFullscreen();
      });

      media?.addEventListener('click',event=>{
        if(event.target.closest('button')||dragMoved)return;
        if(video.paused)playCard(card,false);
        else video.pause();
      });

      updateButtonState(card);
      updateProgress();
    });

    if('IntersectionObserver'in window){
      const cardObserver=new IntersectionObserver(entries=>{
        entries.forEach(entry=>ratios.set(entry.target,entry.intersectionRatio));
        chooseActive();
      },{root:rail,threshold:[0,.2,.4,.55,.7,.9]});
      cards.forEach(card=>cardObserver.observe(card));

      const sectionObserver=new IntersectionObserver(entries=>{
        rootVisible=entries[0].isIntersecting;
        if(!rootVisible)pauseAll();
        else chooseActive();
      },{threshold:.12});
      sectionObserver.observe(root);
    }

    document.addEventListener('visibilitychange',()=>{
      if(document.hidden)pauseAll();
      else chooseActive();
    });

    updateCurrent(0);
  });

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());
  else boot();
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-3d-showcase"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clamp = (value, min = -1, max = 1) => Math.min(max, Math.max(min, value));

  const init = (root) => {
    if (!root || root.dataset.h3dBound === 'true') return;
    root.dataset.h3dBound = 'true';

    const stage = root.querySelector('[data-h3d-stage]');
    const slides = [...root.querySelectorAll('[data-h3d-slide]')];
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const strength = Number(root.dataset.tilt) || 10;
    const delay = Math.max(3000, Number(stage?.dataset.autoplay) || 4200);

    let visible = true;
    let raf = 0;
    let timer = 0;
    let active = 0;
    let changing = false;
    let interacting = false;
    let touchX = 0;
    let touchY = 0;
    let targetX = 0;
    let targetY = 0;
    let currentX = 0;
    let currentY = 0;

    const clearAuto = () => {
      if (timer) window.clearTimeout(timer);
      timer = 0;
    };

    const schedule = () => {
      clearAuto();
      if (reduced || interacting || !visible || document.hidden || slides.length < 2) return;
      timer = window.setTimeout(() => changeTo(active + 1), delay);
    };

    const secondaryLink = root.querySelector('[data-h3d-secondary]');

    const syncUi = () => {
      const featureLink = slides[active]?.querySelector('.h3d-feature');
      if (secondaryLink && featureLink) {
        secondaryLink.href = featureLink.href;
        secondaryLink.textContent = 'VIEW PRODUCT';
        secondaryLink.setAttribute('aria-label', 'View current featured product');
      }
    };

    const changeTo = (index) => {
      if (changing || slides.length < 2) return;
      const nextIndex = (index + slides.length) % slides.length;
      if (nextIndex === active) return schedule();

      changing = true;
      clearAuto();

      const outgoing = slides[active];
      const incoming = slides[nextIndex];

      outgoing.classList.remove('is-active');
      outgoing.classList.add('is-leaving');
      outgoing.setAttribute('aria-hidden', 'true');

      incoming.classList.add('is-active', 'is-entering');
      incoming.setAttribute('aria-hidden', 'false');
      stage?.classList.add('is-changing');

      active = nextIndex;
      syncUi();

      requestAnimationFrame(() => requestAnimationFrame(() => incoming.classList.remove('is-entering')));

      window.setTimeout(() => {
        outgoing.classList.remove('is-leaving');
        stage?.classList.remove('is-changing');
        changing = false;
        schedule();
      }, reduced ? 20 : 840);
    };


    stage?.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      interacting = true;
      touchX = touch.clientX;
      touchY = touch.clientY;
      clearAuto();
    }, { passive: true });

    stage?.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (touch) {
        const dx = touch.clientX - touchX;
        const dy = touch.clientY - touchY;
        if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.2) changeTo(active + (dx < 0 ? 1 : -1));
      }
      interacting = false;
      schedule();
    }, { passive: true });

    const loop = () => {
      currentX += (targetX - currentX) * 0.08;
      currentY += (targetY - currentY) * 0.08;
      root.style.setProperty('--ry', (currentX * strength).toFixed(2) + 'deg');
      root.style.setProperty('--rx', (currentY * strength).toFixed(2) + 'deg');
      root.style.setProperty('--px', (currentX * 14).toFixed(1) + 'px');
      root.style.setProperty('--py', (-currentY * 10).toFixed(1) + 'px');
      if (visible && (Math.abs(targetX - currentX) > 0.002 || Math.abs(targetY - currentY) > 0.002)) raf = requestAnimationFrame(loop);
      else raf = 0;
    };

    const kick = () => {
      if (!raf && visible && !reduced) raf = requestAnimationFrame(loop);
    };

    if (!reduced && stage && root.dataset.tiltEnabled === 'true') {
      const finePointer = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

      if (finePointer) {
        stage.addEventListener('pointermove', (event) => {
          const rect = stage.getBoundingClientRect();
          targetX = clamp(((event.clientX - rect.left) / Math.max(1, rect.width) - 0.5) * 2);
          targetY = clamp(-((event.clientY - rect.top) / Math.max(1, rect.height) - 0.5) * 2);
          kick();
        }, { passive: true });

        stage.addEventListener('pointerenter', () => {
          interacting = true;
          clearAuto();
        });

        stage.addEventListener('pointerleave', () => {
          interacting = false;
          targetX = 0;
          targetY = 0;
          kick();
          schedule();
        });
      } else {
        let gyroActive = false;
        const needsPermission = typeof DeviceOrientationEvent !== 'undefined' && typeof DeviceOrientationEvent.requestPermission === 'function';

        if (typeof DeviceOrientationEvent !== 'undefined' && !needsPermission) {
          window.addEventListener('deviceorientation', (event) => {
            if (event.gamma === null || event.beta === null) return;
            gyroActive = true;
            targetX = clamp(event.gamma / 30);
            targetY = clamp((event.beta - 45) / -30);
            kick();
          }, { passive: true });
        }

        window.addEventListener('scroll', () => {
          if (gyroActive || !visible) return;
          const rect = root.getBoundingClientRect();
          const progress = clamp((rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight);
          targetY = progress * 0.9;
          targetX = progress * -0.35;
          kick();
        }, { passive: true });
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        root.classList.toggle('is-offscreen', !visible);
        if (visible) {
          kick();
          schedule();
        } else {
          clearAuto();
        }
      }, { threshold: .08 }).observe(root);
    }

    document.addEventListener('visibilitychange', schedule);
    syncUi();
    schedule();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-h3d]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-galaxy-3d"] && !Shopify.designMode) return;
  try {
    
(() => {
  const qs = (s, r) =>
    r.querySelector(s);

  const qsa = (s, r) =>
    [...r.querySelectorAll(s)];

  const clamp = (
    v,
    a = -1,
    b = 1
  ) =>
    Math.min(
      b,
      Math.max(a,v)
    );

  const initStars = (
    root,
    canvas,
    reduced
  ) => {
    if(
      !canvas ||
      reduced
    ){
      return;
    }

    const gl =
      canvas.getContext(
        'webgl',
        {
          alpha:true,
          antialias:false,
          depth:false,
          stencil:false,
          powerPreference:'low-power'
        }
      );

    if(!gl){
      return;
    }

    const vertexSource = [
      'attribute vec3 aData;',
      'attribute float aSize;',
      'attribute float aAlpha;',
      'uniform float uTime;',
      'uniform float uDpr;',
      'varying float vAlpha;',
      'void main(){',
      'float driftX=sin(uTime*0.00007+aData.z*17.0)*0.003;',
      'float driftY=cos(uTime*0.000055+aData.z*13.0)*0.0025;',
      'gl_Position=vec4(aData.x+driftX,aData.y+driftY,0.0,1.0);',
      'gl_PointSize=aSize*uDpr;',
      'vAlpha=aAlpha*(0.72+0.28*sin(uTime*0.0015+aData.z*31.0));',
      '}'
    ].join('\n');

    const fragmentSource = [
      'precision mediump float;',
      'varying float vAlpha;',
      'void main(){',
      'vec2 p=gl_PointCoord-vec2(0.5);',
      'float d=length(p);',
      'float alpha=smoothstep(0.5,0.06,d)*vAlpha;',
      'vec3 warm=vec3(0.94,0.82,0.68);',
      'vec3 white=vec3(1.0);',
      'vec3 color=mix(white,warm,0.38);',
      'gl_FragColor=vec4(color,alpha);',
      '}'
    ].join('\n');

    const compile = (
      type,
      source
    ) => {
      const shader =
        gl.createShader(type);

      gl.shaderSource(
        shader,
        source
      );

      gl.compileShader(shader);

      if(
        !gl.getShaderParameter(
          shader,
          gl.COMPILE_STATUS
        )
      ){
        gl.deleteShader(shader);
        return null;
      }

      return shader;
    };

    const vs =
      compile(
        gl.VERTEX_SHADER,
        vertexSource
      );

    const fs =
      compile(
        gl.FRAGMENT_SHADER,
        fragmentSource
      );

    if(
      !vs ||
      !fs
    ){
      return;
    }

    const program =
      gl.createProgram();

    gl.attachShader(
      program,
      vs
    );

    gl.attachShader(
      program,
      fs
    );

    gl.linkProgram(program);

    if(
      !gl.getProgramParameter(
        program,
        gl.LINK_STATUS
      )
    ){
      return;
    }

    gl.useProgram(program);

    const countSetting =
      Math.max(
        24,
        Number(
          root.dataset.stars
        ) || 90
      );

    let count =
      countSetting;

    let raf = 0;
    let visible = true;
    let dpr = 1;

    const posLoc =
      gl.getAttribLocation(
        program,
        'aData'
      );

    const sizeLoc =
      gl.getAttribLocation(
        program,
        'aSize'
      );

    const alphaLoc =
      gl.getAttribLocation(
        program,
        'aAlpha'
      );

    const timeLoc =
      gl.getUniformLocation(
        program,
        'uTime'
      );

    const dprLoc =
      gl.getUniformLocation(
        program,
        'uDpr'
      );

    const posBuffer =
      gl.createBuffer();

    const sizeBuffer =
      gl.createBuffer();

    const alphaBuffer =
      gl.createBuffer();

    const seed = () => {
      count =
        window.innerWidth < 600
          ? Math.max(
              28,
              Math.round(
                countSetting * .58
              )
            )
          : countSetting;

      const positions =
        new Float32Array(
          count * 3
        );

      const sizes =
        new Float32Array(
          count
        );

      const alphas =
        new Float32Array(
          count
        );

      for(
        let i = 0;
        i < count;
        i++
      ){
        positions[i * 3] =
          Math.random() * 2 - 1;

        positions[i * 3 + 1] =
          Math.random() * 2 - 1;

        positions[i * 3 + 2] =
          Math.random();

        const bright =
          Math.random() > .84;

        sizes[i] =
          bright
            ? 1.7 +
              Math.random() * 1.4
            : .7 +
              Math.random() * 1.2;

        alphas[i] =
          bright
            ? .46 +
              Math.random() * .34
            : .12 +
              Math.random() * .32;
      }

      gl.bindBuffer(
        gl.ARRAY_BUFFER,
        posBuffer
      );

      gl.bufferData(
        gl.ARRAY_BUFFER,
        positions,
        gl.STATIC_DRAW
      );

      gl.enableVertexAttribArray(
        posLoc
      );

      gl.vertexAttribPointer(
        posLoc,
        3,
        gl.FLOAT,
        false,
        0,
        0
      );

      gl.bindBuffer(
        gl.ARRAY_BUFFER,
        sizeBuffer
      );

      gl.bufferData(
        gl.ARRAY_BUFFER,
        sizes,
        gl.STATIC_DRAW
      );

      gl.enableVertexAttribArray(
        sizeLoc
      );

      gl.vertexAttribPointer(
        sizeLoc,
        1,
        gl.FLOAT,
        false,
        0,
        0
      );

      gl.bindBuffer(
        gl.ARRAY_BUFFER,
        alphaBuffer
      );

      gl.bufferData(
        gl.ARRAY_BUFFER,
        alphas,
        gl.STATIC_DRAW
      );

      gl.enableVertexAttribArray(
        alphaLoc
      );

      gl.vertexAttribPointer(
        alphaLoc,
        1,
        gl.FLOAT,
        false,
        0,
        0
      );
    };

    const resize = () => {
      const rect =
        root.getBoundingClientRect();

      const width =
        Math.max(
          1,
          Math.round(rect.width)
        );

      const height =
        Math.max(
          1,
          Math.round(rect.height)
        );

      dpr =
        Math.min(
          1.5,
          window.devicePixelRatio || 1
        );

      const nextW =
        Math.max(
          1,
          Math.round(
            width * dpr
          )
        );

      const nextH =
        Math.max(
          1,
          Math.round(
            height * dpr
          )
        );

      if(
        canvas.width !== nextW ||
        canvas.height !== nextH
      ){
        canvas.width = nextW;
        canvas.height = nextH;

        canvas.style.width =
          width + 'px';

        canvas.style.height =
          height + 'px';

        gl.viewport(
          0,
          0,
          nextW,
          nextH
        );
      }

      seed();
    };

    const render = (time) => {
      raf = 0;

      if(
        !visible ||
        document.hidden
      ){
        return;
      }

      gl.clearColor(
        0,
        0,
        0,
        0
      );

      gl.clear(
        gl.COLOR_BUFFER_BIT
      );

      gl.useProgram(program);

      gl.uniform1f(
        timeLoc,
        time
      );

      gl.uniform1f(
        dprLoc,
        dpr
      );

      gl.drawArrays(
        gl.POINTS,
        0,
        count
      );

      raf =
        requestAnimationFrame(
          render
        );
    };

    const start = () => {
      if(
        !raf &&
        visible &&
        !document.hidden
      ){
        raf =
          requestAnimationFrame(
            render
          );
      }
    };

    const stop = () => {
      if(raf){
        cancelAnimationFrame(raf);
      }

      raf = 0;
    };

    let resizeTimer = 0;

    window.addEventListener(
      'resize',
      () => {
        clearTimeout(
          resizeTimer
        );

        resizeTimer =
          window.setTimeout(
            () => {
              resize();
              start();
            },
            120
          );
      },
      {
        passive:true
      }
    );

    if(
      'IntersectionObserver'
      in window
    ){
      new IntersectionObserver(
        entries => {
          visible =
            entries[0]
              .isIntersecting;

          root.classList.toggle(
            'is-paused',
            !visible
          );

          if(visible){
            start();
          } else {
            stop();
          }
        },
        {
          threshold:0
        }
      ).observe(root);
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        if(document.hidden){
          stop();
        } else {
          start();
        }
      }
    );

    resize();
    start();
  };

  const init = root => {
    if(
      !root ||
      root.dataset.ggBound ===
        'true'
    ){
      return;
    }

    root.dataset.ggBound =
      'true';

    const reduced =
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    const copies =
      qsa(
        '[data-gg-copy]',
        root
      );

    const media =
      qsa(
        '[data-gg-media]',
        root
      );

    const commerce =
      qsa(
        '[data-gg-commerce]',
        root
      );

    const dots =
      qsa(
        '[data-gg-dot]',
        root
      );

    const stage =
      qs(
        '[data-gg-stage]',
        root
      );

    const tiltLayer =
      qs(
        '[data-gg-tilt]',
        root
      );

    const status =
      qs(
        '[data-gg-status]',
        root
      );

    const prev =
      qs(
        '[data-gg-prev]',
        root
      );

    const next =
      qs(
        '[data-gg-next]',
        root
      );

    const canvas =
      qs(
        '[data-gg-stars]',
        root
      );

    const count =
      Math.min(
        copies.length,
        media.length,
        commerce.length
      );

    if(!count){
      return;
    }

    let active = 0;
    let timer = 0;
    let paused = false;

    let touchStartX = 0;
    let touchStartY = 0;
    let touching = false;

    const delay =
      Math.max(
        3500,
        Number(
          root.dataset.delay
        ) || 5000
      );

    const autoplay =
      root.dataset.autoplay ===
        'true' &&
      !reduced &&
      count > 1;

    const setPanel = (
      nodes,
      index
    ) => {
      nodes.forEach(
        (node,i) => {
          const on =
            i === index;

          node.classList.toggle(
            'is-active',
            on
          );

          node.setAttribute(
            'aria-hidden',
            on
              ? 'false'
              : 'true'
          );
        }
      );
    };

    const announce =
      index => {
        if(!status){
          return;
        }

        const title =
          copies[index]
            ?.querySelector(
              '.gg3d-title'
            )
            ?.textContent
            ?.trim() || '';

        status.textContent =
          'Showing product ' +
          (index + 1) +
          ' of ' +
          count +
          (
            title
              ? ': ' + title
              : ''
          );
      };

    const clearTimer = () => {
      if(timer){
        window.clearTimeout(
          timer
        );
      }

      timer = 0;
    };

    const schedule = () => {
      clearTimer();

      if(
        !autoplay ||
        paused ||
        document.hidden
      ){
        return;
      }

      timer =
        window.setTimeout(
          () => {
            change(
              active + 1,
              1,
              false
            );

            schedule();
          },
          delay
        );
    };

    const change = (
      index,
      direction = 1,
      userInitiated = false
    ) => {
      const nextIndex =
        (
          index +
          count
        ) %
        count;

      if(
        nextIndex === active &&
        count > 1
      ){
        return;
      }

      root.style.setProperty(
        '--gg-dir',
        direction >= 0
          ? '1'
          : '-1'
      );

      active = nextIndex;

      setPanel(
        copies,
        active
      );

      setPanel(
        media,
        active
      );

      setPanel(
        commerce,
        active
      );

      dots.forEach(
        (dot,i) => {
          const on =
            i === active;

          dot.classList.toggle(
            'is-active',
            on
          );

          dot.setAttribute(
            'aria-current',
            on
              ? 'true'
              : 'false'
          );

          dot.tabIndex =
            on
              ? 0
              : -1;
        }
      );

      const activeDot =
        dots[active];

      activeDot
        ?.scrollIntoView?.(
          {
            block:'nearest',
            inline:'nearest',
            behavior:
              reduced
                ? 'auto'
                : 'smooth'
          }
        );

      announce(active);

      if(userInitiated){
        schedule();
      }
    };

    prev?.addEventListener(
      'click',
      () =>
        change(
          active - 1,
          -1,
          true
        )
    );

    next?.addEventListener(
      'click',
      () =>
        change(
          active + 1,
          1,
          true
        )
    );

    dots.forEach(
      dot =>
        dot.addEventListener(
          'click',
          () => {
            const target =
              Number(
                dot.dataset.ggDot
              );

            change(
              target,
              target >= active
                ? 1
                : -1,
              true
            );
          }
        )
    );

    root.addEventListener(
      'keydown',
      event => {
        if(
          event.key ===
          'ArrowRight'
        ){
          event.preventDefault();

          change(
            active + 1,
            1,
            true
          );
        }

        if(
          event.key ===
          'ArrowLeft'
        ){
          event.preventDefault();

          change(
            active - 1,
            -1,
            true
          );
        }
      }
    );

    root.addEventListener(
      'pointerenter',
      () => {
        if(
          !window
            .matchMedia(
              '(hover:hover) and (pointer:fine)'
            )
            .matches
        ){
          return;
        }

        paused = true;
        clearTimer();
      }
    );

    root.addEventListener(
      'pointerleave',
      () => {
        if(
          !window
            .matchMedia(
              '(hover:hover) and (pointer:fine)'
            )
            .matches
        ){
          return;
        }

        paused = false;
        schedule();
      }
    );

    root.addEventListener(
      'focusin',
      () => {
        paused = true;
        clearTimer();
      }
    );

    root.addEventListener(
      'focusout',
      () => {
        requestAnimationFrame(
          () => {
            if(
              !root.contains(
                document.activeElement
              )
            ){
              paused = false;
              schedule();
            }
          }
        );
      }
    );

    if(
      stage &&
      count > 1
    ){
      stage.addEventListener(
        'touchstart',
        event => {
          const touch =
            event.touches[0];

          if(!touch){
            return;
          }

          touching = true;

          touchStartX =
            touch.clientX;

          touchStartY =
            touch.clientY;

          clearTimer();
        },
        {
          passive:true
        }
      );

      stage.addEventListener(
        'touchend',
        event => {
          if(!touching){
            return;
          }

          touching = false;

          const touch =
            event.changedTouches[0];

          if(!touch){
            schedule();
            return;
          }

          const dx =
            touch.clientX -
            touchStartX;

          const dy =
            touch.clientY -
            touchStartY;

          if(
            Math.abs(dx) > 46 &&
            Math.abs(dx) >
              Math.abs(dy) * 1.15
          ){
            const dir =
              dx < 0
                ? 1
                : -1;

            change(
              active + dir,
              dir,
              true
            );
          } else {
            schedule();
          }
        },
        {
          passive:true
        }
      );
    }

    if(
      stage &&
      tiltLayer &&
      !reduced
    ){
      const strength =
        Math.max(
          2,
          Math.min(
            16,
            Number(
              root.dataset.tilt
            ) || 8
          )
        );

      let tx = 0;
      let ty = 0;
      let cx = 0;
      let cy = 0;
      let tiltRaf = 0;

      const animateTilt =
        () => {
          cx +=
            (tx-cx) * .085;

          cy +=
            (ty-cy) * .085;

          root.style.setProperty(
            '--gg-ry',
            (
              cx *
              strength
            ).toFixed(2) +
            'deg'
          );

          root.style.setProperty(
            '--gg-rx',
            (
              cy *
              strength
            ).toFixed(2) +
            'deg'
          );

          root.style.setProperty(
            '--gg-px',
            (
              cx * 12
            ).toFixed(1) +
            'px'
          );

          root.style.setProperty(
            '--gg-py',
            (
              -cy * 8
            ).toFixed(1) +
            'px'
          );

          if(
            Math.abs(tx-cx) > .002 ||
            Math.abs(ty-cy) > .002
          ){
            tiltRaf =
              requestAnimationFrame(
                animateTilt
              );
          } else {
            tiltRaf = 0;
          }
        };

      const kickTilt =
        () => {
          if(!tiltRaf){
            tiltRaf =
              requestAnimationFrame(
                animateTilt
              );
          }
        };

      if(
        window
          .matchMedia(
            '(hover:hover) and (pointer:fine)'
          )
          .matches
      ){
        stage.addEventListener(
          'pointermove',
          event => {
            const rect =
              stage
                .getBoundingClientRect();

            tx =
              clamp(
                (
                  (
                    event.clientX -
                    rect.left
                  ) /
                  Math.max(
                    1,
                    rect.width
                  ) -
                  .5
                ) *
                2
              );

            ty =
              clamp(
                -(
                  (
                    event.clientY -
                    rect.top
                  ) /
                  Math.max(
                    1,
                    rect.height
                  ) -
                  .5
                ) *
                2
              );

            kickTilt();
          },
          {
            passive:true
          }
        );

        stage.addEventListener(
          'pointerleave',
          () => {
            tx = 0;
            ty = 0;
            kickTilt();
          }
        );
      } else {
        let gyro = false;

        const needsPermission =
          typeof DeviceOrientationEvent !==
            'undefined' &&
          typeof DeviceOrientationEvent
            .requestPermission ===
            'function';

        if(
          typeof DeviceOrientationEvent !==
            'undefined' &&
          !needsPermission
        ){
          window.addEventListener(
            'deviceorientation',
            event => {
              if(
                event.gamma === null ||
                event.beta === null
              ){
                return;
              }

              gyro = true;

              tx =
                clamp(
                  event.gamma /
                  34
                );

              ty =
                clamp(
                  (
                    event.beta -
                    45
                  ) /
                  -36
                );

              kickTilt();
            },
            {
              passive:true
            }
          );
        }

        window.addEventListener(
          'scroll',
          () => {
            if(gyro){
              return;
            }

            const rect =
              root
                .getBoundingClientRect();

            const p =
              clamp(
                (
                  rect.top +
                  rect.height * .5 -
                  window.innerHeight * .5
                ) /
                Math.max(
                  1,
                  window.innerHeight
                )
              );

            tx =
              p * -.22;

            ty =
              p * .46;

            kickTilt();
          },
          {
            passive:true
          }
        );
      }
    }

    document.addEventListener(
      'visibilitychange',
      () => {
        if(document.hidden){
          clearTimer();
        } else {
          schedule();
        }
      }
    );

    initStars(
      root,
      canvas,
      reduced
    );

    dots.forEach(
      (dot,i) => {
        dot.tabIndex =
          i === 0
            ? 0
            : -1;
      }
    );

    announce(0);
    schedule();
  };

  const boot = (
    scope = document
  ) =>
    scope
      .querySelectorAll(
        '[data-gg3d]'
      )
      .forEach(init);

  if(
    document.readyState ===
    'loading'
  ){
    document.addEventListener(
      'DOMContentLoaded',
      () => boot()
    );
  } else {
    boot();
  }

  document.addEventListener(
    'shopify:section:load',
    event =>
      boot(event.target)
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-categories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot=(scope=document)=>scope.querySelectorAll('[data-category-cinema]').forEach(root=>{
    if(root.dataset.categoryCinemaBound==='true')return;
    root.dataset.categoryCinemaBound='true';
    const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const fine=window.matchMedia('(hover:hover) and (pointer:fine)').matches;
    if(reduce||!fine)return;
    root.addEventListener('pointermove',e=>{
      const rect=root.getBoundingClientRect();
      root.style.setProperty('--cat-x',(((e.clientX-rect.left)/Math.max(1,rect.width))*100).toFixed(1)+'%');
      root.style.setProperty('--cat-y',(((e.clientY-rect.top)/Math.max(1,rect.height))*100).toFixed(1)+'%');
    },{passive:true});
    root.querySelectorAll('[data-category-cinema-card]').forEach(card=>{
      let frame=0,x=0,y=0;
      const apply=()=>{frame=0;card.style.transform='perspective(900px) rotateX('+(-y*2.6).toFixed(2)+'deg) rotateY('+(x*3.6).toFixed(2)+'deg) translateY(-3px)'};
      card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect();x=((e.clientX-r.left)/Math.max(1,r.width)-.5)*2;y=((e.clientY-r.top)/Math.max(1,r.height)-.5)*2;card.style.setProperty('--cx',(((e.clientX-r.left)/Math.max(1,r.width))*100).toFixed(1)+'%');card.style.setProperty('--cy',(((e.clientY-r.top)/Math.max(1,r.height))*100).toFixed(1)+'%');if(!frame)frame=requestAnimationFrame(apply)},{passive:true});
      card.addEventListener('pointerleave',()=>{x=0;y=0;card.style.removeProperty('transform')});
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot());else boot();
  document.addEventListener('shopify:section:load',e=>boot(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initFooter = (scope = document) => {
    const mq = window.matchMedia('(max-width: 780px)');
    scope.querySelectorAll('[data-footer-accordion]').forEach((item) => {
      if (item.dataset.footerBound === 'true') return;
      item.dataset.footerBound = 'true';
      const sync = () => { if (mq.matches) item.removeAttribute('open'); else item.setAttribute('open',''); };
      item.addEventListener('toggle', () => {
        if (!mq.matches || !item.open) return;
        scope.querySelectorAll('[data-footer-accordion]').forEach((other) => { if (other !== item) other.removeAttribute('open'); });
      });
      sync();
      mq.addEventListener?.('change', sync);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initFooter());
  else initFooter();
  document.addEventListener('shopify:section:load', (event) => initFooter(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const shell = document.querySelector('[data-gosarte-header]');
  if (!shell || shell.dataset.gosarteHeaderBound === 'true') return;
  shell.dataset.gosarteHeaderBound = 'true';

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const menu = shell.querySelector('.menu-toggle');
  const nav = shell.querySelector('#SiteNav');
  const shopWrap = shell.querySelector('.nav-shop-wrap');
  const shopTrigger = shell.querySelector('.nav-shop-trigger');
  const backdrop = shell.querySelector('[data-mobile-nav-backdrop]');

  let heightRaf = 0;
  const updateHeaderHeight = () => {
    heightRaf = 0;
    const height = Math.ceil(shell.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--gosarte-header-height', height + 'px');
  };
  const scheduleHeaderHeight = () => {
    if (!heightRaf) heightRaf = requestAnimationFrame(updateHeaderHeight);
  };
  if ('ResizeObserver' in window) {
    new ResizeObserver(scheduleHeaderHeight).observe(shell);
  } else {
    window.addEventListener('resize', scheduleHeaderHeight, { passive: true });
  }
  scheduleHeaderHeight();

  let scrollRaf = 0;
  const updateSticky = () => {
    scrollRaf = 0;
    shell.classList.toggle('is-scrolled', window.scrollY > 12);
  };
  window.addEventListener('scroll', () => {
    if (!scrollRaf) scrollRaf = requestAnimationFrame(updateSticky);
  }, { passive: true });
  updateSticky();

  const closeShop = () => {
    shopWrap?.classList.remove('is-open');
    shopTrigger?.setAttribute('aria-expanded', 'false');
  };

  const closeMenu = (restoreFocus = false) => {
    const wasOpen = nav?.classList.contains('is-open');
    nav?.classList.remove('is-open');
    menu?.setAttribute('aria-expanded', 'false');
    menu?.setAttribute('aria-label', 'Open navigation');
    closeShop();
    document.body.classList.remove('menu-open');
    shell.classList.remove('is-menu-open');
    if (restoreFocus && wasOpen) menu?.focus({ preventScroll: true });
  };

  const openMenu = () => {
    nav?.classList.add('is-open');
    menu?.setAttribute('aria-expanded', 'true');
    menu?.setAttribute('aria-label', 'Close navigation');
    document.body.classList.add('menu-open');
    shell.classList.add('is-menu-open');
  };

  menu?.addEventListener('click', () => {
    if (nav?.classList.contains('is-open')) closeMenu(false);
    else openMenu();
  });

  nav?.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', () => closeMenu(false));
  });

  backdrop?.addEventListener('click', () => closeMenu(true));

  shopTrigger?.addEventListener('click', () => {
    const open = !shopWrap?.classList.contains('is-open');
    shopWrap?.classList.toggle('is-open', open);
    shopTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('click', event => {
    if (shopWrap && !shopWrap.contains(event.target)) closeShop();
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && nav?.classList.contains('is-open')) {
      event.preventDefault();
      closeMenu(true);
    }
  });

  const desktopQuery = window.matchMedia('(min-width: 1081px)');
  const handleDesktop = event => {
    if (event.matches) closeMenu(false);
  };
  if (desktopQuery.addEventListener) desktopQuery.addEventListener('change', handleDesktop);
  else desktopQuery.addListener(handleDesktop);

  const closeDialogSmooth = dialog => {
    if (!dialog || !dialog.hasAttribute('open') || dialog.classList.contains('is-closing')) return;
    if (reducedMotion.matches) {
      dialog.close?.();
      if (!dialog.close) dialog.removeAttribute('open');
      return;
    }
    dialog.classList.add('is-closing');
    window.setTimeout(() => {
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
      else dialog.removeAttribute('open');
    }, 260);
  };

  document.querySelectorAll('.gosarte-search-trigger').forEach(trigger => {
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!dialog || trigger.dataset.searchBound === 'true') return;
    trigger.dataset.searchBound = 'true';

    trigger.addEventListener('click', () => {
      closeMenu(false);
      dialog._gosarteOpener = trigger;
      dialog.classList.remove('is-closing');
      if (dialog.showModal) dialog.showModal();
      else dialog.setAttribute('open', '');
      requestAnimationFrame(() => dialog.querySelector('input[type="search"]')?.focus({ preventScroll: true }));
    });
  });

  document.querySelectorAll('.gosarte-search-dialog').forEach(dialog => {
    if (dialog.dataset.dialogBound === 'true') return;
    dialog.dataset.dialogBound = 'true';

    dialog.querySelector('.gosarte-search-close')?.addEventListener('click', () => closeDialogSmooth(dialog));
    dialog.addEventListener('click', event => {
      if (event.target === dialog) closeDialogSmooth(dialog);
    });
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      closeDialogSmooth(dialog);
    });
    dialog.addEventListener('close', () => {
      dialog.classList.remove('is-closing');
      dialog._gosarteOpener?.focus?.({ preventScroll: true });
    });
  });

  const announcement = shell.querySelector('[data-announcement-slider]');
  if (announcement) {
    const slides = [...announcement.querySelectorAll('[data-announcement-slide]')];
    const bar = announcement.querySelector('.gosarte-announcement-progress span');
    const delay = Math.max(3000, Number(announcement.dataset.interval || 5000));
    let index = 0;
    let timer = 0;
    let paused = false;

    const clearTimer = () => {
      if (timer) window.clearTimeout(timer);
      timer = 0;
    };

    const show = next => {
      if (!slides.length) return;
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      if (bar) {
        bar.getAnimations().forEach(animation => animation.cancel());
        if (!reducedMotion.matches && slides.length > 1) {
          bar.animate(
            [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }],
            { duration: delay, easing: 'linear', fill: 'forwards' }
          );
        } else {
          bar.style.transform = 'scaleX(1)';
        }
      }
    };

    const schedule = () => {
      clearTimer();
      if (slides.length < 2 || paused || document.hidden || reducedMotion.matches) return;
      timer = window.setTimeout(() => {
        show(index + 1);
        schedule();
      }, delay);
    };

    announcement.addEventListener('pointerenter', () => {
      paused = true;
      clearTimer();
    });
    announcement.addEventListener('pointerleave', () => {
      paused = false;
      schedule();
    });
    announcement.addEventListener('focusin', () => {
      paused = true;
      clearTimer();
    });
    announcement.addEventListener('focusout', () => {
      paused = false;
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    show(0);
    schedule();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initHero = (scope = document) => {
    scope.querySelectorAll('[data-gosarte-cinematic-hero]').forEach((hero) => {
      if (hero.dataset.cinemaBound === 'true') return;
      hero.dataset.cinemaBound = 'true';
      const stage = hero.querySelector('[data-hero-stage]');
      const parallax = hero.querySelector('[data-hero-parallax]');
      if (!stage || !parallax) return;
      const canParallax = window.matchMedia('(min-width: 901px) and (pointer: fine)').matches && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!canParallax) return;
      let frame = 0;
      const reset = () => {
        parallax.style.setProperty('--hero-x', '0px');
        parallax.style.setProperty('--hero-y', '0px');
        parallax.style.setProperty('--hero-rx', '0deg');
        parallax.style.setProperty('--hero-ry', '0deg');
      };
      stage.addEventListener('pointermove', (event) => {
        const rect = stage.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          parallax.style.setProperty('--hero-x', (x * 15).toFixed(2) + 'px');
          parallax.style.setProperty('--hero-y', (y * 12).toFixed(2) + 'px');
          parallax.style.setProperty('--hero-rx', (-y * 3).toFixed(2) + 'deg');
          parallax.style.setProperty('--hero-ry', (x * 4).toFixed(2) + 'deg');
        });
      });
      stage.addEventListener('pointerleave', reset);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHero());
  else initHero();
  document.addEventListener('shopify:section:load', (event) => initHero(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-home-editorial"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.gritualBound === 'true') return;
    root.dataset.gritualBound = 'true';

    const slides = [...root.querySelectorAll('[data-gritual-slide]')];
    const dots = [...root.querySelectorAll('[data-gritual-dot]')];
    const prev = root.querySelector('[data-gritual-prev]');
    const next = root.querySelector('[data-gritual-next]');
    const stage = root.querySelector('[data-gritual-stage]');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = Math.max(3500, Number(root.dataset.delay) || 5000);

    if (!slides.length) return;

    let active = 0;
    let timer = 0;
    let paused = false;
    let visible = true;
    let touchX = 0;
    let touchY = 0;

    const clearTimer = () => {
      if (timer) window.clearTimeout(timer);
      timer = 0;
    };

    const show = (index) => {
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const on = i === active;
        slide.classList.toggle('is-active', on);
        slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const on = i === active;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-current', on ? 'true' : 'false');
      });
    };

    const schedule = () => {
      clearTimer();
      if (reduce || paused || !visible || document.hidden || slides.length < 2) return;
      timer = window.setTimeout(() => {
        show(active + 1);
        schedule();
      }, delay);
    };

    prev?.addEventListener('click', () => { show(active - 1); schedule(); });
    next?.addEventListener('click', () => { show(active + 1); schedule(); });
    dots.forEach((dot) => dot.addEventListener('click', () => {
      show(Number(dot.dataset.gritualDot));
      schedule();
    }));

    stage?.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      touchX = touch.clientX;
      touchY = touch.clientY;
      clearTimer();
    }, { passive: true });

    stage?.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return schedule();
      const dx = touch.clientX - touchX;
      const dy = touch.clientY - touchY;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.2) show(active + (dx < 0 ? 1 : -1));
      schedule();
    }, { passive: true });

    if (window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
      stage?.addEventListener('pointerenter', () => { paused = true; clearTimer(); });
      stage?.addEventListener('pointerleave', () => { paused = false; schedule(); });

      stage?.addEventListener('pointermove', (event) => {
        const current = slides[active]?.querySelector('[data-gritual-tilt]');
        if (!current) return;
        const rect = stage.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / Math.max(1, rect.width) - .5) * 2;
        const y = ((event.clientY - rect.top) / Math.max(1, rect.height) - .5) * 2;
        current.style.transform = 'rotateX(' + (-y * 4).toFixed(2) + 'deg) rotateY(' + (x * 6).toFixed(2) + 'deg) translate3d(' + (x * 5).toFixed(1) + 'px,' + (y * 3).toFixed(1) + 'px,0)';
      }, { passive: true });

      stage?.addEventListener('pointerleave', () => {
        slides[active]?.querySelector('[data-gritual-tilt]')?.style.removeProperty('transform');
      });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        visible = entries[0].isIntersecting;
        schedule();
      }, { threshold: .08 }).observe(root);
    }

    document.addEventListener('visibilitychange', schedule);
    show(0);
    schedule();
  };

  const boot = (scope = document) => scope.querySelectorAll('[data-gritual]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-home-gifting"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = (scope = document) => {
    scope.querySelectorAll('[data-ggift]').forEach((root) => {
      if (root.dataset.ggiftBound === 'true') return;
      root.dataset.ggiftBound = 'true';

      const visual = root.querySelector('[data-ggift-visual]');
      const tilt = root.querySelector('[data-ggift-tilt]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const fine = window.matchMedia('(hover:hover) and (pointer:fine)').matches;

      if (!visual || !tilt || reduced || !fine) return;

      let raf = 0;
      let tx = 0;
      let ty = 0;
      let cx = 0;
      let cy = 0;

      const animate = () => {
        cx += (tx - cx) * .09;
        cy += (ty - cy) * .09;
        tilt.style.transform = 'rotateX(' + (-cy * 3.4).toFixed(2) + 'deg) rotateY(' + (cx * 4.8).toFixed(2) + 'deg) translate3d(' + (cx * 4).toFixed(1) + 'px,' + (cy * 3).toFixed(1) + 'px,0)';
        if (Math.abs(tx - cx) > .002 || Math.abs(ty - cy) > .002) raf = requestAnimationFrame(animate);
        else raf = 0;
      };

      const kick = () => {
        if (!raf) raf = requestAnimationFrame(animate);
      };

      visual.addEventListener('pointermove', (event) => {
        const rect = visual.getBoundingClientRect();
        tx = ((event.clientX - rect.left) / Math.max(1, rect.width) - .5) * 2;
        ty = ((event.clientY - rect.top) / Math.max(1, rect.height) - .5) * 2;
        root.style.setProperty('--ggift-mx', (((event.clientX - rect.left) / Math.max(1, rect.width)) * 100).toFixed(1) + '%');
        root.style.setProperty('--ggift-my', (((event.clientY - rect.top) / Math.max(1, rect.height)) * 100).toFixed(1) + '%');
        kick();
      }, { passive: true });

      visual.addEventListener('pointerleave', () => {
        tx = 0;
        ty = 0;
        kick();
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-main-cart"]) return;
  try {
    
(() => {
  if (window.__gosarteCartPageBound) return;
  window.__gosarteCartPageBound = true;
  const rootPath = () => window.Shopify?.routes?.root || '/';
  const currency = document.documentElement.dataset.currency || 'INR';
  const locale = document.documentElement.lang || 'en-IN';
  const formatMoney = (cents) => {
    const amount = Number(cents);
    if (!Number.isFinite(amount)) return '';
    try { return new Intl.NumberFormat(locale,{style:'currency',currency}).format(amount/100); }
    catch (_) { return (amount/100).toFixed(2); }
  };
  const syncCount = (cart) => document.querySelectorAll('.cart-count').forEach((node) => { node.textContent=String(cart.item_count); });

  const syncPage = (page, cart) => {
    const content = page.querySelector('[data-cart-page-content]');
    if (!content) return;
    syncCount(cart);
    if (cart.item_count === 0) {
      const template = page.querySelector('[data-cart-empty-template]');
      if (template) content.replaceChildren(template.content.cloneNode(true));
      return;
    }
    page.querySelectorAll('[data-cart-page-key]').forEach((row) => {
      const key = row.dataset.cartPageKey;
      const item = cart.items.find((entry) => entry.key === key);
      if (!item) { row.remove(); return; }
      const input = row.querySelector('[data-cart-page-quantity]');
      const price = row.querySelector('[data-cart-page-line-price]');
      if (input) input.value=String(item.quantity);
      if (price) price.textContent=formatMoney(item.final_line_price);
      row.setAttribute('aria-busy','false');
      row.querySelectorAll('button,input').forEach((control) => { control.disabled=false; });
    });
    const total = page.querySelector('[data-cart-page-total]');
    if (total) total.textContent=formatMoney(cart.total_price);
    const goal = Number(page.dataset.freeShippingThresholdCents||0);
    const progress = page.querySelector('[data-cart-page-shipping]');
    if (progress && goal) {
      const remaining=Math.max(0,goal-Number(cart.total_price||0));
      const percent=Math.min(100,Math.round(Number(cart.total_price||0)*100/goal));
      const message=progress.querySelector('[data-cart-page-shipping-message]');
      if(message)message.textContent=remaining>0?(page.dataset.shippingRemaining||'You’re [amount] away from the free-shipping threshold.').replace('[amount]',formatMoney(remaining)):(page.dataset.shippingUnlocked||'You’ve reached the free-shipping threshold.');
      const fill=progress.querySelector('[data-cart-page-shipping-fill]');if(fill)fill.style.width=percent+'%';
      progress.querySelector('[role="progressbar"]')?.setAttribute('aria-valuenow',String(percent));
    }
  };

  const changeLine = async (page, row, quantity) => {
    const input=row.querySelector('[data-cart-page-quantity]');
    const key=input?.dataset.cartKey||row.dataset.cartPageKey;
    if(!key)return;
    const status=row.querySelector('[data-cart-line-status]');
    row.setAttribute('aria-busy','true');
    row.querySelectorAll('button,input').forEach((control)=>{control.disabled=true;});
    if(status)status.textContent=page.dataset.updatingLabel||'Updating bag';
    try{
      const response=await fetch(rootPath()+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,Number(quantity||0))})});
      const cart=await response.json().catch(()=>null);
      if(!response.ok||!cart)throw new Error();
      syncPage(page,cart);
    }catch(_){
      row.setAttribute('aria-busy','false');
      row.querySelectorAll('button,input').forEach((control)=>{control.disabled=false;});
      if(status)status.textContent=page.dataset.errorLabel||'Bag could not be updated.';
    }
  };

  const timers=new WeakMap();
  document.addEventListener('click',(event)=>{
    const page=event.target.closest('[data-cart-page]')||document.querySelector('[data-cart-page]');
    if(!page)return;
    const row=event.target.closest('[data-cart-page-key]');
    const decrease=event.target.closest('[data-cart-page-decrease]');
    const increase=event.target.closest('[data-cart-page-increase]');
    const remove=event.target.closest('[data-cart-page-remove]');
    if(!row)return;
    const input=row.querySelector('[data-cart-page-quantity]');
    if(decrease){event.preventDefault();if(input)changeLine(page,row,Math.max(1,Number(input.value||1)-1));}
    else if(increase){event.preventDefault();if(input)changeLine(page,row,Number(input.value||1)+1);}
    else if(remove){event.preventDefault();changeLine(page,row,0);}
  });

  document.addEventListener('input',(event)=>{
    const input=event.target.closest('[data-cart-page-quantity]');
    const page=input?.closest('[data-cart-page]');
    const row=input?.closest('[data-cart-page-key]');
    if(!input||!page||!row)return;
    clearTimeout(timers.get(input));
    const timer=setTimeout(()=>changeLine(page,row,Math.max(1,Number(input.value||1))),320);
    timers.set(input,timer);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-main-collection"]) return;
  try {
    
(() => {
  if (window.__gosarteCollectionAjaxBound) return;
  window.__gosarteCollectionAjaxBound = true;
  let filterOpener = null;
  let controller = null;

  const root = () => document.querySelector('[data-collection-root]');
  const dialog = () => root()?.querySelector('[data-collection-filter-dialog]');
  const closeFilters = () => {
    const modal = dialog();
    if (modal?.open) modal.close();
  };
  const restoreFilterFocus = () => {
    if (filterOpener?.isConnected) requestAnimationFrame(() => filterOpener.focus());
    filterOpener = null;
  };

  const updateCollection = async (targetUrl, options = {}) => {
    const current = root();
    if (!current) return;
    const sectionId = current.dataset.sectionId;
    if (!sectionId) { window.location.assign(targetUrl); return; }
    const cleanUrl = new URL(targetUrl, window.location.href);
    const requestUrl = new URL(cleanUrl.href);
    requestUrl.searchParams.set('section_id', sectionId);
    controller?.abort();
    controller = new AbortController();
    closeFilters();
    current.classList.add('is-collection-loading');
    current.setAttribute('aria-busy','true');
    try {
      const response = await fetch(requestUrl, { signal: controller.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error();
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const fresh = parsed.querySelector('[data-collection-root]');
      if (!fresh) throw new Error();
      current.replaceWith(fresh);
      if (options.push !== false) history.pushState({ gosarteCollection: true }, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      window.gosarteSyncWishlist?.();
      window.initLuxeReveals?.(fresh);
      if (options.focus !== false) requestAnimationFrame(() => fresh.querySelector('.collection-control-bar')?.scrollIntoView({ behavior: 'smooth', block: 'start' }));
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(cleanUrl.href);
    }
  };

  document.addEventListener('click', (event) => {
    const current = root();
    if (!current) return;
    const open = event.target.closest('[data-collection-filter-open]');
    if (open && current.contains(open)) {
      event.preventDefault();
      const modal = dialog();
      if (!modal) return;
      filterOpener = open;
      modal.showModal();
      requestAnimationFrame(() => modal.querySelector('input:not(:disabled),button:not([data-collection-filter-close]),summary')?.focus());
      return;
    }
    const close = event.target.closest('[data-collection-filter-close]');
    if (close && current.contains(close)) {
      event.preventDefault();
      closeFilters();
      return;
    }
    const modal = event.target.closest('[data-collection-filter-dialog]');
    if (modal && event.target === modal) {
      closeFilters();
      return;
    }
    const ajaxLink = event.target.closest('[data-collection-ajax-link]');
    if (ajaxLink && current.contains(ajaxLink)) {
      event.preventDefault();
      updateCollection(ajaxLink.href);
    }
  });

  document.addEventListener('close', (event) => {
    if (event.target.matches?.('[data-collection-filter-dialog]')) restoreFilterFocus();
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-collection-sort]');
    if (select && root()?.contains(select)) select.form?.requestSubmit();
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-collection-filter-form],[data-collection-sort-form]');
    if (!form || !root()?.contains(form)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL(form.action || window.location.pathname, window.location.origin);
    const params = new URLSearchParams(new FormData(form));
    url.search = params.toString();
    updateCollection(url.href);
  }, true);

  window.addEventListener('popstate', () => {
    if (root()) updateCollection(window.location.href, { push: false, focus: false });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["noir-search"]) return;
  try {
    
(() => {
  const initSearchPage = (scope = document) => {
    scope.querySelectorAll('[data-search-root]').forEach((root) => {
      if (root.dataset.searchPageBound === 'true') return;
      root.dataset.searchPageBound = 'true';
      const dialog = root.querySelector('[data-search-filter-dialog]');
      const open = root.querySelector('[data-search-filter-open]');
      const close = root.querySelector('[data-search-filter-close]');
      let opener = null;
      open?.addEventListener('click', () => {
        if (!dialog) return;
        opener = open;
        if (dialog.showModal) dialog.showModal();
        else dialog.setAttribute('open','');
        requestAnimationFrame(() => dialog.querySelector('input:not(:disabled),summary,button')?.focus());
      });
      const closeDialog = () => {
        if (!dialog) return;
        if (dialog.open) dialog.close();
        else dialog.removeAttribute('open');
      };
      close?.addEventListener('click', closeDialog);
      dialog?.addEventListener('click', (event) => { if (event.target === dialog) closeDialog(); });
      dialog?.addEventListener('close', () => { if (opener?.isConnected) requestAnimationFrame(() => opener.focus()); opener = null; });
      root.querySelector('[data-search-sort]')?.addEventListener('change', (event) => {
        const formId = event.currentTarget.getAttribute('form');
        const form = formId ? document.getElementById(formId) : null;
        if (form?.requestSubmit) form.requestSubmit();
        else form?.submit();
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initSearchPage());
  else initSearchPage();
  document.addEventListener('shopify:section:load', (event) => initSearchPage(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-attar-tradition"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const section=document.querySelector('[data-vfa2]');
  if(!section)return;
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const steps=[...section.querySelectorAll('[data-vfa2-step]')];
  const kicker=section.querySelector('[data-vfa2-kicker]');
  const scene=section.querySelector('[data-vfa2-scene]');
  let ticking=false;
  const progress=()=>{
    ticking=false;
    const r=section.getBoundingClientRect();
    const travel=Math.max(1,r.height-window.innerHeight);
    const p=Math.min(1,Math.max(0,-r.top/travel));
    section.style.setProperty('--p',p.toFixed(3));
  };
  const onScroll=()=>{if(!ticking){ticking=true;requestAnimationFrame(progress)}};
  if(!reduce)window.addEventListener('scroll',onScroll,{passive:true});
  progress();
  const io=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    steps.forEach(step=>step.classList.remove('is-active'));
    entry.target.classList.add('is-active');
    if(kicker)kicker.textContent=entry.target.dataset.kicker||'';
    if(scene)scene.textContent=entry.target.dataset.scene||'';
  }),{rootMargin:'-34% 0px -34% 0px',threshold:.08});
  steps.forEach(step=>io.observe(step));
  const homeObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{
    if(entry.isIntersecting)entry.target.classList.add('is-vfa2-visible');
  }),{threshold:.08,rootMargin:'0px 0px -7%'});
  document.querySelectorAll('.template-index .vf-section,.template-index .vf-editorial,.template-index .vf-quiz').forEach(el=>{
    [...el.querySelectorAll('.vf-family,.vf-card,.vfd-card,.vf-ingredient')].forEach(card=>card.classList.add('vfa2-stagger'));
    homeObserver.observe(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-faq"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=(root)=>{
    if(!root||root.dataset.vfaqReady==='true')return;
    root.dataset.vfaqReady='true';
    const input=root.querySelector('[data-vfaq-search]');
    const filters=[...root.querySelectorAll('[data-vfaq-filter]')];
    const items=[...root.querySelectorAll('[data-vfaq-item]')];
    const empty=root.querySelector('[data-vfaq-empty]');
    let category='all';
    const apply=()=>{
      const query=(input?.value||'').trim().toLowerCase();
      let visible=0;
      items.forEach(item=>{
        const show=(category==='all'||item.dataset.category===category)&&(!query||(item.dataset.search||'').includes(query));
        item.hidden=!show;
        if(!show)item.open=false;
        if(show)visible++;
      });
      if(empty)empty.hidden=visible>0;
    };
    filters.forEach(button=>button.addEventListener('click',()=>{
      category=button.dataset.vfaqFilter||'all';
      filters.forEach(item=>{
        const active=item===button;
        item.classList.toggle('is-active',active);
        item.setAttribute('aria-pressed',String(active));
      });
      apply();
    }));
    input?.addEventListener('input',apply);
  };
  document.querySelectorAll('[data-vfaq]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll?.('[data-vfaq]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-featured-collection"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=(root)=>{
    if(!root||root.dataset.vfEditReady==='true')return;
    root.dataset.vfEditReady='true';
    const rail=root.querySelector('[data-vf-edit-rail]');
    const move=(direction)=>rail?.scrollBy({left:direction*rail.clientWidth*.72,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    root.querySelector('[data-vf-edit-prev]')?.addEventListener('click',()=>move(-1));
    root.querySelector('[data-vf-edit-next]')?.addEventListener('click',()=>move(1));
    root.addEventListener('submit',(event)=>{
      const form=event.target.closest('[data-vf-edit-quick]');
      if(!form)return;
      const api=window.ValuraaCart;
      if(!api?.addVariant)return;
      event.preventDefault();
      api.addVariant(Number(new FormData(form).get('id')),1,form.querySelector('[data-vf-edit-add]')).catch(()=>{});
    });
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-vf-edit]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-fragrance-header"]) return;
  try {
    
(()=>{
  const init=(header)=>{
    if(!header||header.dataset.vfh3Ready==='true')return;
    header.dataset.vfh3Ready='true';
    const menu=header.querySelector('[data-vfh3-menu]'); const summary=menu?.querySelector('summary'); const drawer=menu?.querySelector('.vfh2__drawer'); const close=header.querySelector('[data-vfh3-close]');
    const search=document.querySelector('[data-vfh3-search]');
    const openSearch=header.querySelector('[data-vfh3-search-open]');
    const closeSearch=search?.querySelector('[data-vfh3-search-close]');
    const input=search?.querySelector('[data-vfh3-search-input]');
    const results=search?.querySelector('[data-vfh3-results]');
    const popular=search?.querySelector('[data-vfh3-popular]');
    let searchTimer=0;
    let searchController=null;
    let searchReturnFocus=null;
    const syncSearchLaunchers=(open)=>document.querySelectorAll('[data-vfh3-search-open],[data-vfdock-search]').forEach((launcher)=>launcher.setAttribute('aria-expanded',String(Boolean(open))));
    const restoreSearchFocus=()=>{
      const target=searchReturnFocus?.isConnected?searchReturnFocus:openSearch;
      searchReturnFocus=null;
      requestAnimationFrame(()=>target?.focus?.({preventScroll:true}));
    };

    const state=()=>header.classList.toggle('is-scrolled',window.scrollY>18);
    const closeMenu=()=>{ if(!menu?.open)return; menu.removeAttribute('open'); summary?.setAttribute('aria-expanded','false'); document.documentElement.classList.remove('vfh2-locked'); summary?.focus(); }; const menuFocusables=()=>drawer?[...drawer.querySelectorAll('a[href],button:not([disabled]),select:not([disabled]),input:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((node)=>!node.hidden&&node.getClientRects().length):[]; const handleMenuKeydown=(event)=>{ if(!menu?.open)return; if(event.key==='Escape'){event.preventDefault();closeMenu();return} if(event.key!=='Tab')return; const focusable=menuFocusables(); if(!focusable.length){event.preventDefault();close?.focus();return} const first=focusable[0]; const last=focusable[focusable.length-1]; if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()} };
    const openSearchDialog=()=>{
      const active=document.activeElement;
      if(active instanceof HTMLElement&&!search?.contains(active))searchReturnFocus=active;
      closeMenu();
      if(!search||typeof search.showModal!=='function')return;
      if(!search.open)search.showModal();
      syncSearchLaunchers(true);
      requestAnimationFrame(()=>input?.focus());
    };
    const closeSearchDialog=()=>{
      searchController?.abort();
      if(search?.open)search.close();
      else{syncSearchLaunchers(false);restoreSearchFocus()}
    };
    const runSearch=()=>{
      window.clearTimeout(searchTimer);
      searchController?.abort();
      const term=input?.value.trim()||'';
      input?.setAttribute('aria-expanded',String(term.length>=2));
      if(popular)popular.hidden=term.length>0;
      if(!results)return;
      if(term.length<2){results.innerHTML='';results.removeAttribute('aria-busy');return}
      searchTimer=window.setTimeout(async()=>{ searchController=new AbortController(); results.setAttribute('aria-busy','true'); try{
          const url=new URL(search.dataset.predictiveUrl,window.location.origin);
          url.searchParams.set('q',term);
          url.searchParams.set('resources[type]','product');
          url.searchParams.set('resources[limit]','6');
          url.searchParams.set('section_id','valuraa-predictive-search');
          const response=await fetch(url,{signal:searchController.signal,headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error();
          const html=await response.text();
          const parsed=new DOMParser().parseFromString(html,'text/html');
          const next=parsed.querySelector('[data-vf-predictive-results]'); results.innerHTML=next?.innerHTML||''; results.removeAttribute('aria-busy'); }catch(error){ if(error.name!=='AbortError'){ results.removeAttribute('aria-busy'); const message=document.createElement('p'); message.className='vfh2-search__message'; message.textContent=search.dataset.searchError||''; results.replaceChildren(message); } }
      },120);
    };

    state();
    window.addEventListener('scroll',state,{passive:true});
    menu?.addEventListener('toggle',()=>{
      const isOpen=Boolean(menu.open);
      summary?.setAttribute('aria-expanded',String(isOpen));
      document.documentElement.classList.toggle('vfh2-locked',isOpen);
      if(isOpen)requestAnimationFrame(()=>close?.focus());
    });
    close?.addEventListener('click',closeMenu); drawer?.addEventListener('keydown',handleMenuKeydown);
    header.querySelectorAll('.vfh2__drawer-nav a').forEach((link)=>link.addEventListener('click',()=>{
      menu?.removeAttribute('open');
      summary?.setAttribute('aria-expanded','false');
      document.documentElement.classList.remove('vfh2-locked');
    }));
    openSearch?.addEventListener('click',openSearchDialog);
    closeSearch?.addEventListener('click',closeSearchDialog);
    search?.addEventListener('click',(event)=>{if(event.target===search)closeSearchDialog()});
    search?.addEventListener('close',()=>{syncSearchLaunchers(false);restoreSearchFocus()});
    search?.addEventListener('cancel',()=>syncSearchLaunchers(false));
    input?.addEventListener('input',runSearch);

    header._vfh3Cleanup=()=>{ window.removeEventListener('scroll',state); drawer?.removeEventListener('keydown',handleMenuKeydown);
      searchController?.abort();
      document.documentElement.classList.remove('vfh2-locked');
    };
  };

  const initAll=(scope=document)=>scope.querySelectorAll('[data-vfh3]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
  document.addEventListener('shopify:section:unload',(event)=>event.target.querySelector('[data-vfh3]')?._vfh3Cleanup?.());
})();

;(()=>{if(window.__ValuraaHeaderFinalV22)return;window.__ValuraaHeaderFinalV22=true;
const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
const search=document.querySelector('[data-vfh3-search]');
const input=search?.querySelector('[data-vfh3-search-input]');
const results=search?.querySelector('[data-vfh3-results]');
const menu=document.querySelector('[data-vfh3-menu]');
const clearAutoHide=()=>document.body.classList.remove('vl-app-scroll-down');
const lockSearch=()=>{
  document.documentElement.classList.add('vfh2-search-locked');
  clearAutoHide();
};
const unlockSearch=()=>document.documentElement.classList.remove('vfh2-search-locked');
if(search){
  if(search.open)lockSearch();
  const observer=new MutationObserver(()=>search.open?lockSearch():unlockSearch());
  observer.observe(search,{attributes:true,attributeFilter:['open']});
  search.addEventListener('close',unlockSearch);
  search.addEventListener('cancel',unlockSearch);
}
menu?.addEventListener('toggle',()=>{
  if(menu.open)clearAutoHide();
});
const links=()=>results?[...results.querySelectorAll('a[href]')].filter(el=>!el.hidden&&el.getClientRects().length):[];
input?.addEventListener('keydown',(event)=>{
  if(event.key==='Escape'&&search?.open){
    event.preventDefault();
    search.close();
    return;
  }
  if(event.key!=='ArrowDown'&&event.key!=='ArrowUp')return;
  const items=links();
  if(!items.length)return;
  event.preventDefault();
  (event.key==='ArrowUp'?items.at(-1):items[0])?.focus();
});
results?.addEventListener('keydown',(event)=>{
  if(event.key==='Escape'&&search?.open){
    event.preventDefault();
    search.close();
    return;
  }
  if(event.key!=='ArrowDown'&&event.key!=='ArrowUp')return;
  const items=links();
  const index=items.indexOf(document.activeElement);
  if(index<0)return;
  event.preventDefault();
  const next=event.key==='ArrowDown'?index+1:index-1;
  if(next<0)input?.focus();
  else if(next>=items.length)input?.focus();
  else items[next]?.focus();
});
search?.addEventListener('click',(event)=>{
  const link=event.target.closest('a[href]');
  if(link)unlockSearch();
});
addEventListener('pageshow',()=>{
  if(!search?.open)unlockSearch();
  if(!menu?.open)document.documentElement.classList.remove('vfh2-locked');
  if(reduced)clearAutoHide();
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-main-collection"] && !Shopify.designMode) return;
  try {
    
(()=>{
  if(window.__vfCollectionBound)return;
  window.__vfCollectionBound=true;
  let controller=null;
  let filterTimer=0;
  const hoverMediaQuery=matchMedia('(hover:hover) and (pointer:fine)');
  const hydrateHoverMedia=(media)=>{
    if(!hoverMediaQuery.matches||!media||media.dataset.vfcHoverReady==='true')return;
    const template=media.querySelector('template[data-vfc-hover-template]');
    if(!template)return;
    media.dataset.vfcHoverReady='true';
    media.appendChild(template.content.cloneNode(true));
    template.remove();
  };

  const getView=()=>{try{return localStorage.getItem('vfCollectionView')||'editorial'}catch(error){return'editorial'}};
  const setView=(value)=>{try{localStorage.setItem('vfCollectionView',value)}catch(error){}};
  const cleanUrl=(url)=>{const next=new URL(url,location.origin);next.searchParams.delete('section_id');return next.pathname+next.search+next.hash};

  const applyView=(root)=>{
    if(!root)return;
    const saved=getView();
    root.classList.toggle('is-compact',saved==='compact');
    root.querySelectorAll('[data-vfc-view]').forEach((button)=>{
      const active=button.dataset.vfcView===saved;
      button.classList.toggle('is-active',active);
      button.setAttribute('aria-pressed',String(active));
    });
  };

  const closeSheets=(root)=>{
    root?.querySelectorAll('[data-vfc-sheet][open]').forEach((sheet)=>sheet.removeAttribute('open'));
    document.documentElement.classList.remove('vfc-sheet-lock');
  };

  const initSheets=(root)=>{
    root?.querySelectorAll('[data-vfc-sheet]').forEach((sheet)=>{
      if(sheet.dataset.vfSheetReady==='true')return;
      sheet.dataset.vfSheetReady='true';
      const panel=sheet.querySelector('[data-vfc-sheet-panel]'); const summary=sheet.querySelector('summary'); const closeButton=panel?.querySelector('[data-vfc-sheet-close-button]'); const grab=sheet.querySelector('.vfc-sheet__grab'); const focusables=()=>panel?[...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])')].filter((node)=>!node.hidden&&node.getClientRects().length):[]; const closeSheet=(restore=true)=>{ if(!sheet.open)return; sheet.removeAttribute('open'); if(restore)requestAnimationFrame(()=>summary?.focus()); }; const handleKeydown=(event)=>{ if(!sheet.open)return; if(event.key==='Escape'){event.preventDefault();closeSheet();return} if(event.key!=='Tab')return; const nodes=focusables(); if(!nodes.length){event.preventDefault();closeButton?.focus();return} const first=nodes[0]; const last=nodes[nodes.length-1]; if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()} }; let startY=0; let dragY=0;

      sheet.addEventListener('toggle',()=>{
        document.documentElement.classList.toggle('vfc-sheet-lock',sheet.open);
        if(sheet.open)requestAnimationFrame(()=>closeButton?.focus());
      });
      sheet.querySelectorAll('[data-vfc-sheet-close]').forEach((button)=>button.addEventListener('click',()=>closeSheet())); panel?.addEventListener('keydown',handleKeydown);

      grab?.addEventListener('pointerdown',(event)=>{
        if(event.pointerType!=='touch')return;
        startY=event.clientY;
        dragY=0;
        grab.setPointerCapture(event.pointerId);
      });
      grab?.addEventListener('pointermove',(event)=>{
        if(!startY||event.pointerType!=='touch')return;
        dragY=Math.max(0,event.clientY-startY);
        if(panel)panel.style.transform='translateY('+dragY+'px)';
      });
      const finish=()=>{
        if(dragY>70)closeSheet();
        if(panel)panel.style.transform='';
        startY=0;
        dragY=0;
      };
      grab?.addEventListener('pointerup',finish);
      grab?.addEventListener('pointercancel',finish);
    });
  };

  const initRoot=(root)=>{applyView(root);initSheets(root)};

  const replaceRoot=(root,nextRoot,url,push=true)=>{
    if(!nextRoot)return;
    closeSheets(root);
    if(getView()==='compact')nextRoot.classList.add('is-compact');
    root.replaceWith(nextRoot);
    if(push)history.pushState({vfCollection:true},'',cleanUrl(url));
    initRoot(nextRoot);
  };

  const fetchSection=async(root,url,push=true)=>{
    controller?.abort();
    controller=new AbortController();
    const loading=root.querySelector('[data-vfc-loading]');
    const errorNode=root.querySelector('[data-vfc-error]');
    if(loading)loading.hidden=false;
    if(errorNode)errorNode.hidden=true;
    root.setAttribute('aria-busy','true');
    closeSheets(root);
    try{
      const requestUrl=new URL(url,location.origin);
      requestUrl.searchParams.set('section_id',root.dataset.sectionId);
      const response=await fetch(requestUrl,{signal:controller.signal,headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error();
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const next=parsed.querySelector('[data-vfc]');
      if(!next)throw new Error();
      replaceRoot(root,next,requestUrl,push);
    }catch(error){
      if(error.name!=='AbortError'){
        if(loading)loading.hidden=true;
        if(errorNode)errorNode.hidden=false;
        root.removeAttribute('aria-busy');
      }
    }
  };

  const urlFromForm=(form)=>{
    const url=new URL(form.action||location.pathname,location.origin);
    new FormData(form).forEach((value,key)=>{if(String(value).trim()!=='')url.searchParams.append(key,String(value))});
    return url;
  };

  const loadMore=async(root,more)=>{
    if(!root||!more||more.dataset.loading==='true')return;
    const nextUrl=more.dataset.nextUrl;
    if(!nextUrl)return;
    more.dataset.loading='true';
    const errorNode=root.querySelector('[data-vfc-error]');
    if(errorNode)errorNode.hidden=true;
    const moreButton=more.querySelector('button');
    if(moreButton){
      moreButton.dataset.vfOriginalLabel=moreButton.textContent;
      moreButton.textContent=root.dataset.loadingLabel||'Loading…';
      moreButton.setAttribute('disabled','');
    }
    root.setAttribute('aria-busy','true');
    try{
      const requestUrl=new URL(nextUrl,location.origin);
      requestUrl.searchParams.set('section_id',root.dataset.sectionId);
      const response=await fetch(requestUrl,{headers:{Accept:'text/html'}});
      if(!response.ok)throw new Error();
      const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
      const nextRoot=parsed.querySelector('[data-vfc]');
      const grid=root.querySelector('[data-vfc-grid]');
      const nextGrid=nextRoot?.querySelector('[data-vfc-grid]');
      if(grid&&nextGrid)[...nextGrid.children].forEach((card)=>grid.appendChild(card));
      const nextMore=nextRoot?.querySelector('[data-vfc-more]');
      if(nextMore)more.replaceWith(nextMore);else more.remove();
      root.removeAttribute('aria-busy');
    }catch(error){
      more.dataset.loading='false';
      if(moreButton){
        moreButton.removeAttribute('disabled');
        moreButton.textContent=moreButton.dataset.vfOriginalLabel||more.dataset.vfcMoreLabel||'Load more';
      }
      root.removeAttribute('aria-busy');
      if(errorNode)errorNode.hidden=false;
    }
  };

  document.addEventListener('submit',(event)=>{
    const form=event.target.closest?.('[data-vfc-ajax]');
    const root=form?.closest('[data-vfc]');
    if(form&&root){event.preventDefault();fetchSection(root,urlFromForm(form),true)}
  });

  document.addEventListener('change',(event)=>{
    const root=event.target.closest?.('[data-vfc]');
    if(!root)return;
    if(event.target.matches('[data-vfc-sort] select')){event.target.closest('form')?.requestSubmit();return}
    if(event.target.matches('[data-vfc-ajax] input[type="checkbox"]')){ const form=event.target.closest('form'); if(form?.classList.contains('vfc-sheet__form'))return; clearTimeout(filterTimer); filterTimer=setTimeout(()=>form?.requestSubmit(),140); }
  });

  document.addEventListener('pointerover',(event)=>{
    if(!hoverMediaQuery.matches)return;
    const media=event.target.closest?.('.vfc-card__media');
    if(media)hydrateHoverMedia(media);
  },{passive:true});

  document.addEventListener('click',(event)=>{
    const viewButton=event.target.closest('[data-vfc-view]');
    if(viewButton){const root=viewButton.closest('[data-vfc]');setView(viewButton.dataset.vfcView||'editorial');applyView(root);return}
    const filterLink=event.target.closest('[data-vfc-filter-link]');
    if(filterLink){const root=filterLink.closest('[data-vfc]');if(root){event.preventDefault();fetchSection(root,filterLink.href,true)}return}
    const moreButton=event.target.closest('[data-vfc-more] button');
    if(moreButton){const more=moreButton.closest('[data-vfc-more]');loadMore(more.closest('[data-vfc]'),more)}
  });

  document.addEventListener('submit',(event)=>{
    const form=event.target.closest?.('[data-vfc-quick-form]');
    if(!form)return;
    const api=window.ValuraaCart;
    if(!api?.addVariant)return;
    event.preventDefault();
    api.addVariant(Number(new FormData(form).get('id')),1,form.querySelector('[data-vfc-quick-add]')).catch(()=>{});
  });

  document.addEventListener('keydown',(event)=>{
    if(event.key!=='Escape')return;
    const root=document.querySelector('[data-vfc]');
    if(root)closeSheets(root);
  });
  addEventListener('popstate',()=>{const root=document.querySelector('[data-vfc]');if(root)fetchSection(root,location.href,false)});
  document.querySelectorAll('[data-vfc]').forEach(initRoot);
  document.addEventListener('shopify:section:load',(event)=>{const root=event.target.querySelector('[data-vfc]');if(root)initRoot(root)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-main-product"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=(root)=>{
    if(!root||root.dataset.vfProductReady==='true')return;
    root.dataset.vfProductReady='true';

    const select=root.querySelector('[data-vf-variant]');
    const fallback=root.querySelector('[data-vf-select-fallback]');
    const pills=root.querySelector('[data-vf-option-pills]');
    const groups=[...root.querySelectorAll('[data-vf-option-group]')];
    const json=root.querySelector('[data-vf-variants]');
    const price=root.querySelector('[data-vf-price]');
    const compare=root.querySelector('[data-vf-compare]');
    const discount=root.querySelector('[data-vf-discount]');
    const sku=root.querySelector('[data-vf-sku]');
    const skuRow=sku?.closest('.vfp-sku');
    const stickyPrice=root.querySelector('[data-vf-sticky-price]');
    const stickyThumb=root.querySelector('.vfp-sticky__thumb-img');
    const stickyThumbWrap=root.querySelector('[data-vf-sticky-thumb-wrap]');
    const stickyVariant=root.querySelector('[data-vf-sticky-variant]');
    const stickySelect=root.querySelector('[data-vf-sticky-select]');
    const add=root.querySelector('[data-vf-add]');
    const stickyAdd=root.querySelector('[data-vf-sticky-add]');
    const stickyBuy=root.querySelector('[data-vf-sticky-buy]');
    const sticky=root.querySelector('.vfp-sticky');
    const mobileDock=document.querySelector('[data-vfdock]');
    let stickyDockObserver=null;
    const syncStickyDockOffset=()=>{
      if(!sticky)return;
      const mobile=matchMedia('(max-width:899px)').matches;
      const dockHeight=mobile&&mobileDock?Math.ceil(mobileDock.getBoundingClientRect().height):0;
      sticky.style.setProperty('--vfp-sticky-bottom',(dockHeight+8)+'px');
    };
    syncStickyDockOffset();
    if(sticky&&mobileDock&&'ResizeObserver'in window){
      stickyDockObserver=new ResizeObserver(syncStickyDockOffset);
      stickyDockObserver.observe(mobileDock);
    }
    window.addEventListener('resize',syncStickyDockOffset,{passive:true});
    const gallery=root.querySelector('[data-vf-gallery]');
    const medias=[...root.querySelectorAll('[data-vf-media-id]')];
    const mediaCounter=root.querySelector('[data-vf-media-counter]');
    const variantStatus=root.querySelector('[data-vf-variant-status]');
    const zoom=root.querySelector('[data-vf-zoom]');
    const zoomImage=root.querySelector('[data-vf-zoom-image]');
    const zoomStage=root.querySelector('[data-vf-zoom-stage]');
    let variants=[];

    try{variants=JSON.parse(json?.textContent||'[]')}catch(error){variants=[]}

    const currency=document.documentElement.dataset.currency||'USD';
    const money=(cents)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(cents/100);
    const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches||root.dataset.vfMotion==='false';

    const setButtonLabel=(button,text)=>{
      const label=button?.querySelector('[data-vf-trigger-label]');
      if(label)label.textContent=text||'';
      else if(button)button.textContent=text||'';
    };
    const setButtons=(available)=>{
      [add,stickyAdd].forEach((button)=>{
        if(!button)return;
        button.disabled=!available;
        setButtonLabel(button,available?root.dataset.vfAddLabel||button.dataset.availableLabel||'':root.dataset.vfSoldLabel||button.dataset.soldLabel||'');
      });
    };

    if(add){
      add.dataset.availableLabel=add.querySelector('[data-vf-trigger-label]')?.textContent.trim()||'';
      add.dataset.soldLabel=root.dataset.vfSoldLabel||'';
    }
    if(stickyAdd){
      stickyAdd.dataset.availableLabel=stickyAdd.querySelector('[data-vf-trigger-label]')?.textContent.trim()||'';
      stickyAdd.dataset.soldLabel=root.dataset.vfSoldLabel||'';
    }

    const updateMediaState=(id,animate=false)=>{
      const index=medias.findIndex((media)=>media.dataset.vfMediaId===String(id));
      root.querySelectorAll('[data-vf-thumb]').forEach((thumb)=>thumb.classList.toggle('is-active',thumb.dataset.mediaId===String(id)));
      root.querySelectorAll('[data-vf-dot]').forEach((dot)=>dot.setAttribute('aria-current',String(dot.dataset.mediaId===String(id))));
      if(mediaCounter&&index>=0)mediaCounter.textContent=(index+1)+' / '+medias.length;
      if(animate&&index>=0&&!reduced){
        const media=medias[index];
        media.classList.remove('is-variant-focus');
        requestAnimationFrame(()=>media.classList.add('is-variant-focus'));
        window.setTimeout(()=>media.classList.remove('is-variant-focus'),520);
      }
    };
    const announceVariant=(variant)=>{
      if(!variantStatus)return;
      const template=root.dataset.vfVariantSelectedTemplate||'';
      variantStatus.textContent=template.replace('__VARIANT__',variant.title||'').replace('__PRICE__',money(variant.price));
    };
    const pulseVariant=()=>{
      if(reduced)return;
      root.classList.remove('is-variant-changing');
      requestAnimationFrame(()=>root.classList.add('is-variant-changing'));
      window.setTimeout(()=>root.classList.remove('is-variant-changing'),380);
    };

    const scrollMedia=(variant)=>{
      const mediaId=variant?.featured_media?.id;
      if(!mediaId)return;
      const media=root.querySelector('[data-vf-media-id="'+mediaId+'"]');
      if(!media)return;
      updateMediaState(mediaId,true);
      if(matchMedia('(max-width:899px)').matches)media.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest',inline:'start'});
      else media.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest'});
    };

    const applyVariant=(variant,updateUrl=true)=>{
      if(!variant)return;
      if(select)select.value=String(variant.id);
      if(stickySelect)stickySelect.value=String(variant.id);
      if(price)price.textContent=money(variant.price);
      if(stickyPrice)stickyPrice.textContent=money(variant.price);
      const nextThumb=variant?.featured_media?.preview_image?.src||variant?.featured_image?.src||'';
      if(stickyThumb&&nextThumb){
        stickyThumb.src=nextThumb;
        stickyThumb.srcset='';
        if(stickyThumbWrap&&!reduced){
          stickyThumbWrap.classList.remove('is-refreshing');
          requestAnimationFrame(()=>stickyThumbWrap.classList.add('is-refreshing'));
          window.setTimeout(()=>stickyThumbWrap.classList.remove('is-refreshing'),520);
        }
      }
      if(stickyVariant){stickyVariant.hidden=variant.title==='Default Title';stickyVariant.textContent=variant.title==='Default Title'?'':variant.title;}
      const sale=Number(variant.compare_at_price)>Number(variant.price);
      if(compare){compare.hidden=!sale;compare.textContent=sale?money(variant.compare_at_price):''}
      if(discount){
        discount.hidden=!sale;
        discount.textContent=sale?(root.dataset.vfSaveTemplate||'').replace('__PERCENT__',String(Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100))):'';
      }
      if(sku){
        sku.textContent=variant.sku||'';
        if(skuRow)skuRow.hidden=!variant.sku;
      }
      setButtons(Boolean(variant.available));
      pulseVariant();
      announceVariant(variant);
      if(updateUrl){
        const url=new URL(location.href);
        url.searchParams.set('variant',variant.id);
        history.replaceState({},'',url);
      }
      scrollMedia(variant);
    };

    const selectedValues=()=>groups.map((group)=>group.querySelector('input:checked')?.value||'');

    const variantFromPills=()=>{
      const values=selectedValues();
      return variants.find((variant)=>variant.options?.every((value,index)=>String(value)===String(values[index])));
    };

    const syncOptionAvailability=()=>{
      groups.forEach((group,index)=>{
        const prior=groups.slice(0,index).map((previous)=>previous.querySelector('input:checked')?.value||'');
        const radios=[...group.querySelectorAll('input[type=radio]')];

        radios.forEach((input)=>{
          const available=variants.some((variant)=>{
            if(!variant.available)return false;
            if(String(variant.options?.[index]||'')!==String(input.value))return false;
            return prior.every((value,priorIndex)=>!value||String(variant.options?.[priorIndex]||'')===String(value));
          });

          input.disabled=!available;
          input.labels?.[0]?.classList.toggle('is-unavailable',!available);
        });

        const checked=group.querySelector('input:checked');
        if(checked?.disabled){
          const firstAvailable=radios.find((input)=>!input.disabled);
          if(firstAvailable)firstAvailable.checked=true;
        }
      });
    };

    const syncPillsToVariant=(variant)=>{
      if(!variant)return;
      groups.forEach((group,index)=>{
        const radio=[...group.querySelectorAll('input[type=radio]')].find((input)=>input.value===String(variant.options?.[index]||''));
        if(radio)radio.checked=true;
      });
      syncOptionAvailability();
    };

    if(select&&pills&&groups.length){
      fallback.hidden=true;
      pills.hidden=false;
      syncOptionAvailability();

      groups.forEach((group)=>group.addEventListener('change',()=>{
        syncOptionAvailability();
        const variant=variantFromPills();
        if(variant)applyVariant(variant,true);
      }));
    }

    select?.addEventListener('change',()=>{
      const variant=variants.find((item)=>String(item.id)===select.value);
      if(!variant)return;
      syncPillsToVariant(variant);
      applyVariant(variant,true);
    });

    stickySelect?.addEventListener('change',()=>{
      const variant=variants.find((item)=>String(item.id)===stickySelect.value);
      if(!variant)return;
      syncPillsToVariant(variant);
      applyVariant(variant,true);
    });

    root.querySelectorAll('[data-vf-dot]').forEach((dot)=>dot.addEventListener('click',()=>{
      const media=root.querySelector('[data-vf-media-id="'+dot.dataset.mediaId+'"]');
      media?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest',inline:'start'});
    }));

    root.querySelectorAll('[data-vf-thumb]').forEach((thumb)=>thumb.addEventListener('click',()=>{
      const media=root.querySelector('[data-vf-media-id="'+thumb.dataset.mediaId+'"]');
      media?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest'});
    }));

    root.querySelectorAll('[data-vf-zoom-open]').forEach((button)=>{
      let lastTap=0;
      let tapTimer=0;
      const openZoom=()=>{
        if(!zoom||!zoomImage)return;
        const sourceImage=button.querySelector('img');
        zoomImage.src=button.dataset.vfZoomSrc||'';
        zoomImage.alt=sourceImage?.alt||'';
        if(typeof zoom.showModal==='function')zoom.showModal();
      };

      button.addEventListener('pointermove',(event)=>{
        if(event.pointerType!=='mouse')return;
        const rect=button.getBoundingClientRect();
        const x=((event.clientX-rect.left)/rect.width)*100;
        const y=((event.clientY-rect.top)/rect.height)*100;
        button.style.setProperty('--vf-zoom-x',x+'%');
        button.style.setProperty('--vf-zoom-y',y+'%');
      });

      button.addEventListener('click',(event)=>{
        if(event.detail===0||matchMedia('(pointer:fine)').matches){
          openZoom();
          return;
        }
        const now=Date.now();
        if(now-lastTap<340){
          window.clearTimeout(tapTimer);
          button.classList.remove('is-awaiting-zoom');
          lastTap=0;
          navigator.vibrate?.(5);
          openZoom();
          return;
        }
        lastTap=now;
        button.classList.add('is-awaiting-zoom');
        tapTimer=window.setTimeout(()=>button.classList.remove('is-awaiting-zoom'),360);
      });
    });
    let zoomScale=1;
    let zoomX=0;
    let zoomY=0;
    let pinchDistance=0;
    let zoomFrame=0;
    const pointers=new Map();
    const paintZoomTransform=()=>{
      zoomFrame=0;
      if(zoomImage)zoomImage.style.transform='translate3d('+zoomX+'px,'+zoomY+'px,0) scale('+zoomScale+')';
    };
    const applyZoomTransform=()=>{
      if(!zoomFrame)zoomFrame=requestAnimationFrame(paintZoomTransform);
    };
    const resetZoomTransform=()=>{
      if(zoomFrame){cancelAnimationFrame(zoomFrame);zoomFrame=0}
      zoomScale=1;zoomX=0;zoomY=0;pinchDistance=0;pointers.clear();paintZoomTransform();
    };
    const pointerDistance=()=>{
      const points=[...pointers.values()];
      if(points.length<2)return 0;
      return Math.hypot(points[0].x-points[1].x,points[0].y-points[1].y);
    };
    zoomStage?.addEventListener('pointerdown',(event)=>{
      if(event.pointerType==='mouse')return;
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      zoomStage.setPointerCapture?.(event.pointerId);
      if(pointers.size===2)pinchDistance=pointerDistance();
    });
    zoomStage?.addEventListener('pointermove',(event)=>{
      if(!pointers.has(event.pointerId))return;
      const previous=pointers.get(event.pointerId);
      pointers.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if(pointers.size===2){
        const distance=pointerDistance();
        if(pinchDistance>0){
          zoomScale=Math.max(1,Math.min(4,zoomScale*(distance/pinchDistance)));
          applyZoomTransform();
        }
        pinchDistance=distance;
      }else if(pointers.size===1&&zoomScale>1&&previous){
        zoomX+=event.clientX-previous.x;
        zoomY+=event.clientY-previous.y;
        applyZoomTransform();
      }
    });
    const releasePointer=(event)=>{
      pointers.delete(event.pointerId);
      pinchDistance=pointers.size===2?pointerDistance():0;
    };
    zoomStage?.addEventListener('pointerup',releasePointer);
    zoomStage?.addEventListener('pointercancel',releasePointer);
    zoomStage?.addEventListener('dblclick',()=>{zoomScale=zoomScale>1?1:2;if(zoomScale===1){zoomX=0;zoomY=0}applyZoomTransform()});
    root.querySelector('[data-vf-zoom-close]')?.addEventListener('click',()=>{resetZoomTransform();zoom?.close()});
    zoom?.addEventListener('click',(event)=>{if(event.target===zoom){resetZoomTransform();zoom.close()}});
    zoom?.addEventListener('close',resetZoomTransform);

    root.querySelector('[data-vfp-discovery-add]')?.addEventListener('click',(event)=>{
      const button=event.currentTarget;
      const variantId=Number(button.dataset.variantId);
      if(!variantId||!window.ValuraaCart?.addVariant)return;
      const original=button.textContent;
      button.disabled=true;
      button.textContent=button.dataset.addingLabel||original;
      window.ValuraaCart.addVariant(variantId,1,button).then(()=>{
        button.textContent=button.dataset.addedLabel||original;
        window.setTimeout(()=>{if(button.isConnected){button.disabled=false;button.textContent=original}},1100);
      }).catch(()=>{
        if(button.isConnected){button.disabled=false;button.textContent=original}
      });
    });

    stickyAdd?.addEventListener('click',()=>{
      if(!reduced){
        stickyAdd.classList.remove('is-celebrate');
        requestAnimationFrame(()=>stickyAdd.classList.add('is-celebrate'));
        window.setTimeout(()=>stickyAdd.classList.remove('is-celebrate'),650);
      }
      add?.click();
    });

    stickyBuy?.addEventListener('click',()=>{
      if(stickyBuy.disabled)return;
      const dynamic=root.querySelector('.shopify-payment-button__button');
      if(dynamic){
        if(!reduced)navigator.vibrate?.(4);
        dynamic.click();
        return;
      }
      add?.scrollIntoView({behavior:reduced?'auto':'smooth',block:'center'});
      add?.focus();
    });

    if(add&&sticky){
      const footer=document.querySelector('.vff4');
      if('IntersectionObserver'in window){
        let addVisible=true;
        let footerVisible=false;
        const syncSticky=()=>{
          const mobile=matchMedia('(max-width:899px)').matches;
          sticky.classList.toggle('is-visible',!addVisible&&(!footerVisible||mobile)&&window.scrollY>120);
          if(sticky.classList.contains('is-visible'))syncStickyDockOffset();
        };
        const observer=new IntersectionObserver((entries)=>{
          entries.forEach((entry)=>{
            if(entry.target===add)addVisible=entry.isIntersecting;
            else if(entry.target===footer)footerVisible=entry.isIntersecting;
          });
          syncSticky();
        },{threshold:.02});
        observer.observe(add);
        if(footer)observer.observe(footer);
        root._vfStickyObserver=observer;
      }else sticky.classList.add('is-visible');
    }

    if(medias.length)updateMediaState(medias[0].dataset.vfMediaId,false);
    if(gallery&&'IntersectionObserver'in window){
      let lastMediaId='';
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
          if(!entry.isIntersecting)return;
          const id=entry.target.dataset.vfMediaId;
          updateMediaState(id,false);
          if(id!==lastMediaId&&!reduced&&matchMedia('(pointer:coarse)').matches)navigator.vibrate?.(4);
          lastMediaId=id;
        });
      },{threshold:.55});
      medias.forEach((media)=>observer.observe(media));
      root._vfMediaObserver=observer;
    }

    root._vfProductCleanup=()=>{
      root._vfStickyObserver?.disconnect();
      root._vfMediaObserver?.disconnect();
      if(zoomFrame)cancelAnimationFrame(zoomFrame);
    };
  };

  const initAll=(scope=document)=>scope.querySelectorAll('[data-vf-product]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
  document.addEventListener('shopify:section:unload',(event)=>event.target.querySelector('[data-vf-product]')?._vfProductCleanup?.());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-mobile-dock"]) return;
  try {
    
(()=>{
  const init=(dock)=>{
    if(!dock||dock.dataset.vfDockReady==='true')return;
    dock.dataset.vfDockReady='true';
    const path=location.pathname;
    let active=null;
    if(path==='/')active=dock.querySelector('[data-vfdock-home]');
    else if(path.startsWith('/collections')||path.startsWith('/products/'))active=dock.querySelector('[data-vfdock-collections]');
    else if(path.startsWith('/cart'))active=dock.querySelector('[data-vfdock-cart]');
    else if(path.startsWith('/search'))active=dock.querySelector('[data-vfdock-search]');
    active?.setAttribute('aria-current','page');
    dock.querySelector('[data-vfdock-search]')?.addEventListener('click',()=>{
      const search=document.querySelector('[data-vfh3-search-open]');
      if(search){navigator.vibrate?.(4);search.click()}else location.href=dock.dataset.searchUrl||'/search';
    });
    dock.querySelector('[data-vfdock-finder-link]')?.addEventListener('click',(event)=>{
      const url=new URL(event.currentTarget.href,location.origin);
      if(location.pathname==='/'&&url.hash==='#vf-home-finder'){
        event.preventDefault();
        document.querySelector('#vf-home-finder')?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
      }
    });
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-vfdock]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-product-noir-v2"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=(root)=>{
    if(!root||root.dataset.vpdReady==='true')return;
    root.dataset.vpdReady='true';

    const form=root.querySelector('.vpd-form');
    const select=root.querySelector('[data-vpd-variant-select]');
    const fallback=root.querySelector('[data-vpd-select-fallback]');
    const options=root.querySelector('[data-vpd-options]');
    const groups=[...root.querySelectorAll('[data-vpd-option-group]')];
    const variantsNode=root.querySelector('[data-vpd-variants]');
    const price=root.querySelector('[data-vpd-price]');
    const compare=root.querySelector('[data-vpd-compare]');
    const discount=root.querySelector('[data-vpd-discount]');
    const add=root.querySelector('[data-vf-add]');
    const sticky=root.querySelector('[data-vpd-sticky]');
    const stickyAdd=root.querySelector('[data-vf-sticky-add]');
    const stickyPrice=root.querySelector('[data-vpd-sticky-price]');
    const stickySelect=root.querySelector('[data-vpd-sticky-select]');
    const status=root.querySelector('[data-vpd-variant-status]');
    const gallery=root.querySelector('[data-vpd-gallery]');
    const medias=[...root.querySelectorAll('[data-vpd-media]')];
    const counter=root.querySelector('[data-vpd-counter]');
    const zoom=root.querySelector('[data-vpd-zoom]');
    const zoomImage=root.querySelector('[data-vpd-zoom-image]');
    const dock=document.querySelector('[data-vfdock]');
    const reduced=matchMedia('(prefers-reduced-motion:reduce)').matches||root.dataset.vfMotion==='false';
    let variants=[];
    try{variants=JSON.parse(variantsNode?.textContent||'[]')}catch(error){variants=[]}

    const currency=root.dataset.vpdCurrency||'USD';
    const money=(cents)=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency}).format(Number(cents||0)/100);
    const label=(button,text)=>{const target=button?.querySelector('[data-vf-trigger-label]');if(target)target.textContent=text||''};
    const setAvailability=(variant)=>{
      const available=Boolean(variant?.available);
      [add,stickyAdd].forEach((button)=>{if(button){button.disabled=!available;label(button,available?root.dataset.vfAddLabel:root.dataset.vfSoldLabel)}});
    };

    const updateMedia=(id)=>{
      const media=medias.find((item)=>String(item.dataset.mediaId)===String(id));
      if(!media)return;
      media.scrollIntoView({behavior:reduced?'auto':'smooth',block:'nearest',inline:'start'});
    };
    const updateGalleryState=(id)=>{
      const index=medias.findIndex((item)=>String(item.dataset.mediaId)===String(id));
      if(index<0)return;
      if(counter)counter.textContent=(index+1)+' / '+medias.length;
      root.querySelectorAll('[data-vpd-dot]').forEach((dot)=>dot.setAttribute('aria-current',String(dot.dataset.mediaId)===String(id)?'true':'false'));
      root.querySelectorAll('[data-vpd-thumb]').forEach((thumb)=>thumb.setAttribute('aria-current',String(thumb.dataset.mediaId)===String(id)?'true':'false'));
    };

    const syncAvailability=()=>{
      groups.forEach((group,index)=>{
        const prior=groups.slice(0,index).map((g)=>g.querySelector('input:checked')?.value||'');
        [...group.querySelectorAll('input[type=radio]')].forEach((input)=>{
          const available=variants.some((variant)=>{
            if(!variant.available)return false;
            if(String(variant.options?.[index]||'')!==String(input.value))return false;
            return prior.every((value,priorIndex)=>!value||String(variant.options?.[priorIndex]||'')===String(value));
          });
          input.disabled=!available;
        });
      });
    };

    const findVariant=()=>variants.find((variant)=>variant.options?.every((value,index)=>String(value)===String(groups[index]?.querySelector('input:checked')?.value||'')));
    const syncPills=(variant)=>{
      groups.forEach((group,index)=>{
        const radio=[...group.querySelectorAll('input[type=radio]')].find((input)=>String(input.value)===String(variant.options?.[index]||''));
        if(radio)radio.checked=true;
      });
      syncAvailability();
    };

    const applyVariant=(variant,updateUrl=true)=>{
      if(!variant)return;
      if(select)select.value=String(variant.id);
      if(stickySelect)stickySelect.value=String(variant.id);
      if(price)price.textContent=money(variant.price);
      if(stickyPrice)stickyPrice.textContent=money(variant.price);
      const sale=Number(variant.compare_at_price)>Number(variant.price);
      if(compare){compare.hidden=!sale;compare.textContent=sale?money(variant.compare_at_price):''}
      if(discount){
        discount.hidden=!sale;
        if(sale){
          const percent=Math.round(((variant.compare_at_price-variant.price)/variant.compare_at_price)*100);
          discount.textContent=(root.dataset.vpdSaveTemplate||'').replace('__PERCENT__',String(percent));
        }
      }
      setAvailability(variant);
      if(status)status.textContent=(variant.title||'')+' · '+money(variant.price);
      const mediaId=variant.featured_media?.id;
      if(mediaId)updateMedia(mediaId);
      if(updateUrl){
        const url=new URL(location.href);
        url.searchParams.set('variant',variant.id);
        history.replaceState({},'',url);
      }
    };

    if(select&&options&&groups.length){
      fallback.hidden=true;
      options.hidden=false;
      syncAvailability();
      groups.forEach((group)=>group.addEventListener('change',()=>{
        syncAvailability();
        const variant=findVariant();
        if(variant)applyVariant(variant,true);
      }));
    }

    select?.addEventListener('change',()=>{
      const variant=variants.find((item)=>String(item.id)===String(select.value));
      if(variant){syncPills(variant);applyVariant(variant,true)}
    });
    stickySelect?.addEventListener('change',()=>{
      const variant=variants.find((item)=>String(item.id)===String(stickySelect.value));
      if(variant){syncPills(variant);applyVariant(variant,true)}
    });

    root.querySelectorAll('[data-vpd-dot],[data-vpd-thumb]').forEach((button)=>button.addEventListener('click',()=>updateMedia(button.dataset.mediaId)));

    if(gallery&&medias.length&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{if(entry.isIntersecting)updateGalleryState(entry.target.dataset.mediaId)});
      },{root:gallery,threshold:.58});
      medias.forEach((media)=>observer.observe(media));
      root._vpdMediaObserver=observer;
    }else if(medias[0])updateGalleryState(medias[0].dataset.mediaId);

    root.querySelectorAll('[data-vpd-zoom-open]').forEach((button)=>button.addEventListener('click',()=>{
      if(!zoom||!zoomImage)return;
      zoomImage.src=button.dataset.zoomSrc||'';
      zoomImage.alt=button.querySelector('img')?.alt||'';
      zoom.showModal?.();
    }));
    root.querySelector('[data-vpd-zoom-close]')?.addEventListener('click',()=>zoom?.close());
    zoom?.addEventListener('click',(event)=>{if(event.target===zoom)zoom.close()});

    const qty=form?.querySelector('input[name="quantity"]');
    root.querySelector('[data-vpd-qty-minus]')?.addEventListener('click',()=>{if(qty)qty.value=String(Math.max(1,(Number(qty.value)||1)-1))});
    root.querySelector('[data-vpd-qty-plus]')?.addEventListener('click',()=>{if(qty)qty.value=String(Math.max(1,(Number(qty.value)||1)+1))});

    root.querySelector('[data-vpd-discovery-add]')?.addEventListener('click',(event)=>{
      const button=event.currentTarget;
      const id=Number(button.dataset.variantId);
      if(!id||!window.ValuraaCart?.addVariant)return;
      const original=button.textContent;
      button.disabled=true;
      window.ValuraaCart.addVariant(id,1,button).then(()=>{button.textContent=root.dataset.vfAddedLabel||original;setTimeout(()=>{if(button.isConnected){button.disabled=false;button.textContent=original}},900)}).catch(()=>{if(button.isConnected){button.disabled=false;button.textContent=original}});
    });

    stickyAdd?.addEventListener('click',()=>add?.click());

    const syncDock=()=>{
      if(!sticky)return;
      const height=matchMedia('(max-width:899px)').matches&&dock?Math.ceil(dock.getBoundingClientRect().height):0;
      sticky.style.setProperty('--vpd-dock',height+'px');
    };
    syncDock();
    let dockObserver=null;
    if(sticky&&dock&&'ResizeObserver'in window){dockObserver=new ResizeObserver(syncDock);dockObserver.observe(dock)}
    window.addEventListener('resize',syncDock,{passive:true});

    if(add&&sticky&&'IntersectionObserver'in window){
      const observer=new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>sticky.classList.toggle('is-visible',!entry.isIntersecting&&window.scrollY>120));
      },{threshold:.05});
      observer.observe(add);
      root._vpdStickyObserver=observer;
    }

    root._vpdCleanup=()=>{
      root._vpdMediaObserver?.disconnect();
      root._vpdStickyObserver?.disconnect();
      dockObserver?.disconnect();
      window.removeEventListener('resize',syncDock);
    };
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-vpd-root]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
  document.addEventListener('shopify:section:unload',(event)=>event.target.querySelector('[data-vpd-root]')?._vpdCleanup?.());
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-recently-viewed"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const key='valuraa_recent_products_v1';
  const escapeHtml=(value='')=>String(value).replace(/[&<>"']/g,(char)=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[char]));
  const init=(root)=>{
    if(!root||root.dataset.vfrvReady==='true')return;
    root.dataset.vfrvReady='true';
    const data=root.querySelector('[data-vfrv-current]');
    const rail=root.querySelector('[data-vfrv-rail]');
    if(!data||!rail)return;
    let current={};let saved=[];
    try{current=JSON.parse(data.textContent||'{}')}catch(error){}
    try{const value=JSON.parse(localStorage.getItem(key)||'[]');saved=Array.isArray(value)?value:[]}catch(error){}
    const previous=saved.filter((item)=>item?.handle&&item.handle!==current.handle).slice(0,4);
    previous.forEach((item)=>{
      const card=document.createElement('article');
      card.className='vfrv-card';
      const media=item.image?'<div class="vfrv-card__media"><img src="'+escapeHtml(item.image)+'" width="'+(Number(item.width)||1)+'" height="'+(Number(item.height)||1)+'" loading="lazy" decoding="async" alt="'+escapeHtml(item.imageAlt||item.title)+'"></div>':'';
      const currentCurrency=document.documentElement.dataset.currency||'';
      const safePrice=!item.currency||!currentCurrency||item.currency===currentCurrency?(item.price||''):'';
      card.innerHTML='<a href="'+escapeHtml(item.url||('/products/'+item.handle))+'">'+media+'<div class="vfrv-card__body">'+(item.format?'<small>'+escapeHtml(item.format)+'</small>':'')+'<h3>'+escapeHtml(item.title||'')+'</h3>'+(safePrice?'<strong>'+escapeHtml(safePrice)+'</strong>':'')+'</div></a>';
      rail.appendChild(card);
    });
    if(previous.length)root.hidden=false;
    const next=[current,...saved.filter((item)=>item?.handle&&item.handle!==current.handle)].filter((item)=>item?.handle).slice(0,8);
    try{localStorage.setItem(key,JSON.stringify(next))}catch(error){}
  };
  document.querySelectorAll('[data-vfrv]').forEach(init);
  document.addEventListener('shopify:section:load',(event)=>event.target.querySelectorAll?.('[data-vfrv]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-related-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('valuraa-product-recommendations')){
  customElements.define('valuraa-product-recommendations',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.loaded==='true'||!this.dataset.url)return;
      this.dataset.loaded='true';
      const load=async()=>{
        try{
          const response=await fetch(this.dataset.url,{headers:{Accept:'text/html'}});
          if(!response.ok)throw new Error();
          const html=await response.text();
          const parsed=new DOMParser().parseFromString(html,'text/html');
          const next=parsed.querySelector('valuraa-product-recommendations');
          if(next&&next.innerHTML.trim())this.innerHTML=next.innerHTML;
          else this.remove();
        }catch(error){this.remove()}
      };
      if('IntersectionObserver'in window){
        const observer=new IntersectionObserver((entries)=>{
          if(!entries.some((entry)=>entry.isIntersecting))return;
          observer.disconnect();
          load();
        },{rootMargin:'0px 0px 280px 0px'});
        observer.observe(this);
        this._observer=observer;
      }else load();
    }
    disconnectedCallback(){this._observer?.disconnect()}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-scent-concierge"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root)=>{if(!root||root.dataset.vscReady==='true')return;root.dataset.vscReady='true';
const launcher=root.querySelector('[data-vsc-launcher]');const panel=root.querySelector('[data-vsc-panel]');const close=root.querySelector('[data-vsc-close]');const nudge=root.querySelector('[data-vsc-nudge]');const nudgeClose=root.querySelector('[data-vsc-nudge-close]');if(!launcher||!panel)return;
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
const footer=document.querySelector('.vff4');
if(footer&&'IntersectionObserver'in window){
  const footerObserver=new IntersectionObserver((entries)=>{
    root.classList.toggle('is-footer-near',entries.some(entry=>entry.isIntersecting));
  },{threshold:.01,rootMargin:'0px 0px 90px 0px'});
  footerObserver.observe(footer);
}
let lastY=window.scrollY,idleTimer=0,ticking=false;
const onScroll=()=>{ticking=false;const y=window.scrollY;if(!panel.hidden){root.classList.remove('is-scroll-hidden');lastY=y;return}
  if(y>lastY+6&&y>240)root.classList.add('is-scroll-hidden');else if(y<lastY-6)root.classList.remove('is-scroll-hidden');lastY=y;
  clearTimeout(idleTimer);idleTimer=setTimeout(()=>root.classList.remove('is-scroll-hidden'),1100)};
window.addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(onScroll)}},{passive:true});
const hideNudge=(persist=false)=>{if(nudge){nudge.hidden=true;nudge.setAttribute('hidden','')}if(persist){root.classList.add('is-nudge-dismissed');try{sessionStorage.setItem('valuraa_scent_concierge_nudge','1')}catch(e){}}};
const open=()=>{hideNudge();panel.hidden=false;root.classList.add('is-open');launcher.setAttribute('aria-expanded','true');requestAnimationFrame(()=>close?.focus({preventScroll:true}))};
const shut=()=>{panel.hidden=true;root.classList.remove('is-open');launcher.setAttribute('aria-expanded','false');launcher.focus({preventScroll:true})};
launcher.addEventListener('click',()=>panel.hidden?open():shut());close?.addEventListener('click',shut);
const dismissNudge=(event)=>{event?.preventDefault?.();event?.stopPropagation?.();event?.stopImmediatePropagation?.();hideNudge(true);};
nudgeClose?.addEventListener('pointerup',dismissNudge,{capture:true});
nudgeClose?.addEventListener('click',dismissNudge,{capture:true});
nudge?.addEventListener('click',event=>{if(event.target.closest('button'))return;open()});
root.addEventListener('click',event=>{const search=event.target.closest('[data-vsc-search]');if(search){event.preventDefault();shut();const trigger=document.querySelector('[data-vfh3-search-open]');if(trigger)requestAnimationFrame(()=>trigger.click());else location.href=root.dataset.vscSearchUrl||'/search';return}
const scroll=event.target.closest('[data-vsc-scroll]');if(scroll){event.preventDefault();const target=document.querySelector(scroll.dataset.vscScroll);if(target){shut();target.scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});requestAnimationFrame(()=>target.querySelector?.('button,a,input,select')?.focus?.({preventScroll:true}))}}});
document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden)shut()});
document.addEventListener('click',event=>{if(panel.hidden||root.contains(event.target))return;shut()},{capture:true});
if(root.dataset.vscAutoNudge==='true'&&nudge&&!matchMedia('(max-width:899px)').matches){let seen=false;try{seen=sessionStorage.getItem('valuraa_scent_concierge_nudge')==='1'}catch(e){}if(seen){root.classList.add('is-nudge-dismissed');hideNudge()}else{const delay=Math.max(2000,Number(root.dataset.vscNudgeDelay)||6000);window.setTimeout(()=>{if(!root.isConnected||!panel.hidden||root.classList.contains('is-nudge-dismissed'))return;nudge.hidden=false;nudge.removeAttribute('hidden');window.setTimeout(()=>{if(nudge&&!nudge.hidden)hideNudge()},4200)},delay)}}
};
document.querySelectorAll('[data-vsc]').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll?.('[data-vsc]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valuraa-scent-finder"] && !Shopify.designMode) return;
  try {
    
(()=>{
  const init=(root)=>{
    if(!root||root.dataset.vfFinderReady==='true')return;
    root.dataset.vfFinderReady='true';
    const result=root.querySelector('[data-vf-finder-result]');
    const link=root.querySelector('[data-vf-finder-link]');
    const update=()=>{
      const family=root.querySelector('input[name="vf-family"]:checked')?.value||'';
      const intensity=root.querySelector('input[name="vf-intensity"]:checked')?.value||'Balanced';
      if(!family){
        if(result)result.textContent='';
        if(link)link.hidden=true;
        return;
      }
      if(result)result.textContent=(root.dataset.resultTemplate||'').replace('__FAMILY__',family);
      if(link){
        const url=new URL(root.dataset.searchUrl,window.location.origin);
        url.searchParams.set('q',[family,intensity,'fragrance'].join(' '));
        url.searchParams.set('type','product');
        link.href=url.pathname+url.search;
        link.hidden=false;
      }
    };
    root.addEventListener('change',update);
    update();
  };
  const initAll=(scope=document)=>scope.querySelectorAll('[data-vf-finder]').forEach(init);
  initAll();
  document.addEventListener('shopify:section:load',(event)=>initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
